(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /*
    Two jobs, and neither of them can be done in CSS.

    One: take the lines in turn. Every swap moves both the outgoing and the
    incoming line upward at once, so the bar reads as one strip of text
    scrolling past rather than as two elements crossfading. The bar keeps still
    while it is hovered or holds the keyboard focus, and while the tab is in the
    background — WCAG 2.2.2 asks for a way to stop content that updates by
    itself, and a strip this small has no room for a button that would do it.

    Two: walk the header up as a bar that scrolls away leaves the screen. That
    one needs the scroll position, which is the one thing a stylesheet cannot
    read; everything else about the bar is CSS.
  */
  const ANNOUNCEMENT_TRANSITION_MS = 500;

  /*
    Which bar owns --announcement-shift on <html>. The property outlives the
    element that wrote it — an inline style does — so a bar leaving the page has
    to take its value with it, or the fixed header stays translated up by 20px
    over a strip that is no longer there. In the theme editor that happens for
    real: deleting the section rewrites the DOM without reloading the page.

    Ownership rather than a plain clear on disconnect, because a section that is
    re-rendered mounts its replacement around the same moment its old element
    goes: whichever bar registered last keeps the value, and one that never
    registered clears nothing.
  */
  let announcementShiftOwner = null;

  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.follow();
      this.rotate();
    }

    disconnectedCallback() {
      this.stop();

      if (this.messages) {
        this.messages.forEach((message) => clearTimeout(message.resetTimer));
      }

      document.removeEventListener('visibilitychange', this.syncVisibility);
      window.removeEventListener('scroll', this.queueShift);
      window.removeEventListener('resize', this.queueShift);
      if (this.frame) cancelAnimationFrame(this.frame);

      if (announcementShiftOwner === this) this.releaseShift();
    }

    /*
      A bar that stays on screen never moves and the header keeps its place under
      it. A bar that scrolls away leaves the header behind, 20px lower than it
      would stand on a shop with no bar — so the header is walked up on the bar's
      bottom edge until it lands at the top of the window.
    */
    follow() {
      if (this.classList.contains('announcement-bar--sticky')) {
        this.releaseShift();
        return;
      }

      announcementShiftOwner = this;
      this.shift = -1;
      this.syncShift = this.syncShift.bind(this);
      this.queueShift = this.queueShift.bind(this);

      window.addEventListener('scroll', this.queueShift, { passive: true });
      window.addEventListener('resize', this.queueShift, { passive: true });

      this.syncShift();
    }

    releaseShift() {
      announcementShiftOwner = null;
      document.documentElement.style.removeProperty('--announcement-shift');
    }

    queueShift() {
      // At most one write per frame, however many scroll events arrive in it.
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.syncShift();
      });
    }

    syncShift() {
      const travel = Math.min(Math.max(window.scrollY, 0), this.offsetHeight);

      /*
        Once the bar is fully off the top there is nothing left to move, and the
        value stops changing for the whole rest of the page. Without this the
        header would be handed an identical transform on every frame of every
        scroll — the same work, and none of it visible.
      */
      if (travel === this.shift) return;

      this.shift = travel;
      document.documentElement.style.setProperty('--announcement-shift', travel + 'px');
    }

    rotate() {
      this.messages = Array.from(this.querySelectorAll('[data-announcement]'));

      // One line has nothing to take turns with; CSS already shows it.
      if (this.messages.length < 2) return;

      this.index = 0;
      this.messages.forEach((message, position) => {
        this.dress(message, position === 0 ? 'current' : 'waiting');
      });

      this.interval = Number(this.dataset.interval) || 5000;
      this.advance = this.advance.bind(this);
      this.start = this.start.bind(this);
      this.stop = this.stop.bind(this);
      this.syncVisibility = this.syncVisibility.bind(this);
      this.toggleHold = this.toggleHold.bind(this);

      this.addEventListener('pointerenter', this.stop);
      this.addEventListener('pointerleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);
      document.addEventListener('visibilitychange', this.syncVisibility);

      /*
        The toggle is printed hidden and only becomes real here — from this line
        on there is something for it to stop. Hover and focus hold the lines on
        their own, but a phone has neither, and the button is the only mechanism
        a touch visitor has.
      */
      this.holdButton = this.querySelector('[data-announcement-hold]');
      if (this.holdButton) {
        this.holdButton.hidden = false;
        this.holdButton.addEventListener('click', this.toggleHold);
      }

      this.start();
    }

    /*
      State and the accessibility tree move together: the line on show is the
      only one exposed, so what a screen reader reads is what is on the strip.
    */
    dress(message, state) {
      message.dataset.state = state;

      if (state === 'current') {
        message.removeAttribute('aria-hidden');
      } else {
        message.setAttribute('aria-hidden', 'true');
      }
    }

    toggleHold() {
      this.held = !this.held;
      this.holdButton.setAttribute('aria-pressed', String(this.held));

      if (this.held) {
        this.stop();
      } else {
        this.start();
      }
    }

    start() {
      // A held bar stays held through a pointer leaving it or focus moving on.
      if (this.held || document.hidden) return;
      this.stop();
      this.timer = setInterval(this.advance, this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = 0;
    }

    syncVisibility() {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    }

    advance() {
      const leaving = this.messages[this.index];
      this.index = (this.index + 1) % this.messages.length;
      const arriving = this.messages[this.index];

      this.dress(leaving, 'leaving');
      this.dress(arriving, 'current');

      /*
        Once it is off the top the line has to go back under the bar, ready for
        its next turn — and get there without animating, or it would be seen
        falling back through the text that has just replaced it. The wait is the
        CSS transition duration, so the constant above and the transition in the
        stylesheet only ever change together.
      */
      clearTimeout(leaving.resetTimer);
      leaving.resetTimer = setTimeout(() => {
        leaving.dataset.reset = '';
        leaving.dataset.state = 'waiting';
        // Read a layout property to make the jump land before transitions return.
        void leaving.offsetHeight;
        delete leaving.dataset.reset;
      }, ANNOUNCEMENT_TRANSITION_MS);
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-panel"] && !Shopify.designMode) return;
  try {
    
  /*
    Three jobs: keep the selects and the variant in step, leaf through the
    photos, and hand the submit to the shared cart layer in assets/theme.js.

    Whether it is on screen is a fourth, and it is documented above update():
    the panel belongs to a group of sections and shows itself only while its
    resting place falls inside that group.
  */
  class BuyPanel extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-variant-id]');
      /*
        All of them, not the first of each: the price is printed twice — on the
        title row for a phone and inside the button from 750 — and only one copy
        is on screen at a time (snippets/buy-panel-price.liquid). Writing to the
        first alone would leave whichever copy the reader is actually looking at
        showing the price of the variant that was chosen when the page loaded.
      */
      this.priceOutputs = Array.from(this.querySelectorAll('[data-price]'));
      this.compareOutputs = Array.from(this.querySelectorAll('[data-compare]'));
      this.compareAmounts = Array.from(this.querySelectorAll('[data-compare-amount]'));
      this.priceLabels = Array.from(this.querySelectorAll('[data-price-label]'));
      this.status = this.querySelector('[data-status]');
      this.submit = this.querySelector('[data-submit]');
      // The select components, not their <details>: they own their own opening.
      this.selects = Array.from(this.querySelectorAll('variant-select'));
      this.mediaLink = this.querySelector('[data-media-link]');
      this.frames = Array.from(this.querySelectorAll('[data-media] .buy-panel__frame'));

      const json = this.querySelector('[data-buy-panel-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];

      this.frameIndex = 0;
      this.showFrame(0);
      this.checkFirstIfEmpty();

      this.onSelectChange = this.onSelectChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onCartChanged = this.onCartChanged.bind(this);

      // Delegation: change from a radio bubbles, and one subscription survives
      // any number of options.
      this.addEventListener('change', this.onSelectChange);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);

      document.addEventListener('cart:updated', this.onCartChanged);
      document.addEventListener('cart:refreshed', this.onCartChanged);

      /*
        The markup does not carry what is already in the cart: the panel cannot
        be re-rendered, and Liquid would have counted it once, at load. So it is
        asked for directly — otherwise a shopper returning to a product page
        with a full cart would see a live button where there is nothing left to
        take.
      */
      this.onCartChanged({});

      this.watchScroll();
      this.startRotation();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartChanged);
      document.removeEventListener('cart:refreshed', this.onCartChanged);
      this.stopRotation();
      // The editor tears a section down mid-request often enough to matter: the
      // timer would otherwise fire against a button that is no longer on the page.
      clearTimeout(this.loadingTimer);
      // The editor tears the section down mid-animation often enough for this
      // to matter: otherwise the timer fires against an element that is no
      // longer on the page.
      if (this.frame) cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.queue);
      window.removeEventListener('resize', this.remeasure);
      window.removeEventListener('load', this.remeasure);
      document.removeEventListener('shopify:section:load', this.remeasure);
      document.removeEventListener('shopify:section:unload', this.remeasure);
      document.removeEventListener('shopify:section:reorder', this.remeasure);
      this.removeEventListener('change', this.onSelectChange);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
    }

    /* ---- variant ---------------------------------------------------------- */

    get selectedVariant() {
      const chosen = this.selects.map((select) => {
        const checked = select.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      return this.variants.find((variant) =>
        variant.options.every((option, index) => option === chosen[index])
      );
    }

    /*
      selected_value returns the first available variant, and when none is
      available it may match nothing at all, leaving the group with no checked
      button. A <select> would silently pick its first item in that case; a radio
      group cannot, so the first item is checked here.
    */
    checkFirstIfEmpty() {
      this.selects.forEach((select) => {
        if (select.querySelector('input:checked')) return;
        const first = select.querySelector('input');
        if (!first) return;

        first.checked = true;
        /*
          The check was set without a change event, so the trigger's label does
          not update by itself. The call is guarded: if the component has not
          been upgraded by the browser yet, it paints its own trigger in its
          connectedCallback.
        */
        if (typeof select.syncTrigger === 'function') select.syncTrigger();
      });
    }

    onSelectChange() {
      const variant = this.selectedVariant;

      if (!variant) {
        // A combination the merchant never made. Say so rather than fail on submit.
        this.setSubmitState(false, this.dataset.unavailableLabel);
        return;
      }

      this.variantInput.value = variant.id;
      /*
        The photo leads to the product page, and it leads to the variant that is
        picked here — otherwise the page opens on the first colour and the choice
        made in the panel is lost on the way.
      */
      if (this.mediaLink) {
        this.mediaLink.href = `${this.mediaLink.dataset.productUrl}?variant=${variant.id}`;
      }
      this.renderPrice(variant);
      this.setSubmitState(this.canAdd(variant), this.submitLabelFor(variant));

      /*
        Jump to the cut-out of the colour that was picked, when there is one.
        It matches by id, so it only fires if the same file is both the
        variant's image and a panel frame — with one cut-out per product,
        as today, nothing matches and the rotation simply carries on. Per-colour
        cut-outs are a shoot away; see docs/store-content.md.
      */
      if (variant.imageId) {
        const index = this.frames.findIndex(
          (frame) => frame.dataset.imageId === String(variant.imageId)
        );
        if (index > -1) {
          this.showFrame(index);
          this.restartRotation();
        }
      }
    }

    /*
      The hidden label on the current price switches with it: otherwise, on
      sale, a screen reader announces "Sale price 60 EUR" next to an old price
      with no label at all.
    */
    renderPrice(variant) {
      const label = variant.compareAtPrice ? this.dataset.saleLabel : this.dataset.regularLabel;

      this.priceOutputs.forEach((node) => {
        node.textContent = variant.price;
      });
      this.priceLabels.forEach((node) => {
        node.textContent = label;
      });
      this.compareOutputs.forEach((node) => {
        node.hidden = !variant.compareAtPrice;
      });
      if (!variant.compareAtPrice) return;

      this.compareAmounts.forEach((node) => {
        node.textContent = variant.compareAtPrice;
      });
    }


    /*
      Whether one more of this variant can still be added.

      The same ceiling Liquid works out on a cart line, only here it has to be
      worked out on the client: the panel cannot be re-rendered as a section —
      the chosen variant lives in the DOM and swapping the markup would drop the
      choice. How much is already in the cart arrives with the cart:updated
      event.
    */
    canAdd(variant) {
      if (!variant || !variant.available) return false;
      return !this.maxedOut(variant);
    }

    /*
      The variant's entire stock is already in the cart. Kept apart from
      `available`: there the store has run out, here the shopper has taken
      everything there was.
    */
    maxedOut(variant) {
      if (!variant || !variant.inventoryManaged) return false;
      if (variant.inventoryPolicy === 'continue') return false;

      const inCart = (this.inCart && this.inCart[variant.id]) || 0;

      /*
        Nothing of it in the cart means the shopper cannot have taken all of it,
        whatever the stock says. Without this line an empty cart claimed "the
        maximum quantity of this item is already in your cart" on a sold-out
        variant — which is both false and the wrong sentence: the shop ran out,
        the shopper did nothing.
      */
      if (inCart === 0) return false;

      /*
        `inventory_quantity` is null on the storefront for a variant whose stock
        this shop cannot read, and every variant of this store currently answers
        null. `0 >= null` is `0 >= 0` in JavaScript — true — which is exactly how
        the false message got out. An unknown stock is not a reached limit.
      */
      if (typeof variant.inventoryQuantity !== 'number') return false;

      return inCart >= variant.inventoryQuantity;
    }

    /*
      The cart changed — recount how many of each variant it holds and decide
      again whether the button is live. cart:refreshed is listened for too:
      after a refusal the number in the cart may have changed, and the panel
      would otherwise never find out.
    */
    onCartChanged(event) {
      const cart = event.detail && event.detail.cart;

      if (cart && cart.items) {
        this.inCart = {};
        cart.items.forEach((item) => {
          this.inCart[item.variant_id] = (this.inCart[item.variant_id] || 0) + item.quantity;
        });
        this.applyLimit();
        return;
      }

      // cart:refreshed brings section markup only — the count is fetched separately.
      window.Theme.fetchCart()
        .then((fresh) => {
          this.inCart = {};
          fresh.items.forEach((item) => {
            this.inCart[item.variant_id] = (this.inCart[item.variant_id] || 0) + item.quantity;
          });
          this.applyLimit();
        })
        .catch(() => {});
    }

    /*
      Disable the button and say why. The reason is shown at the moment of
      disabling rather than on click: a disabled button cannot be clicked any
      more, and Shopify's review checklist requires a message rather than
      silence.
    */
    applyLimit() {
      const variant = this.selectedVariant;
      this.setSubmitState(this.canAdd(variant), this.submitLabelFor(variant));

      if (this.maxedOut(variant)) {
        this.showStatus(this.dataset.maxLabel || '', true);
      } else if (this.status.hasAttribute('data-error')) {
        this.showStatus('', false);
      }
    }

    /*
      What the button should read. A variant the shop has run out of says so:
      until now it kept "Add to cart" and merely went inert, which tells a
      shopper who cannot see the greying nothing at all. The reason the cart is
      full is a different sentence and lives in the status line, not here.
    */
    submitLabelFor(variant) {
      if (variant && !variant.available) return this.dataset.soldOutLabel;
      return this.dataset.addLabel;
    }

    setSubmitState(enabled, label) {
      if (!this.submit) return;
      // aria-disabled rather than disabled: a disabled button drops out of the
      // tab order, and someone arriving by keyboard should still find out why.
      this.submit.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      this.setSubmitLabel(label);
    }

    /* ---- photos ----------------------------------------------------------- */

    showFrame(index) {
      if (!this.frames.length) return;
      this.frameIndex = (index + this.frames.length) % this.frames.length;
      this.frames.forEach((frame, i) => {
        frame.toggleAttribute('data-active', i === this.frameIndex);
      });
    }

    startRotation() {
      const seconds = Number(this.dataset.interval);
      if (!seconds || this.frames.length < 2) return;
      // Auto-updating content is motion; a reduced-motion visitor gets one photo.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.timer = setInterval(() => this.showFrame(this.frameIndex + 1), seconds * 1000);

      // WCAG asks for a way to stop it. Pointing at or tabbing into the panel
      // is that way — you cannot read a spec that keeps changing under you.
      this.addEventListener('pointerenter', () => this.stopRotation());
      this.addEventListener('pointerleave', () => this.restartRotation());
      this.addEventListener('focusin', () => this.stopRotation());
    }

    stopRotation() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    restartRotation() {
      this.stopRotation();
      const seconds = Number(this.dataset.interval);
      if (!seconds || this.frames.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.showFrame(this.frameIndex + 1), seconds * 1000);
    }

    /* ---- cart ------------------------------------------------------------- */

    async onSubmit(event) {
      event.preventDefault();

      if (this.submit.getAttribute('aria-disabled') === 'true') return;

      this.setSubmitState(false);
      this.showStatus('', false);
      this.startLoading();

      try {
        await window.Theme.addToCart([{ id: Number(this.variantInput.value), quantity: 1 }]);
        this.showStatus(this.dataset.addedLabel || '', false);
      } catch (error) {
        this.showStatus(error.message, true);
        /*
          A refusal on stock does not mean the cart was left alone: Shopify
          puts the available maximum in and answers 422 anyway. The count is
          re-read, or the button stays live on an exhausted variant.
        */
        this.onCartChanged({});
      } finally {
        // Before setSubmitState: it owns the label in the unavailable case, and
        // stopLoading puts the resting one back unconditionally.
        this.stopLoading();
        const variant = this.selectedVariant;
        this.setSubmitState(!variant || this.canAdd(variant));
      }
    }

    /*
      One entry point for success and for refusal: data-error decides whether
      the text is shown on screen or left to the screen reader alone. There is
      nothing to show for success — the cart drawer slides out by itself.
    */
    showStatus(message, isError) {
      this.status.textContent = message;

      if (isError && message) {
        this.status.setAttribute('data-error', '');
      } else {
        this.status.removeAttribute('data-error');
      }
    }

    /*
      Shopify answers /cart/add in roughly 200-400ms on a warm connection, and a
      spinner painted on the first frame is a flicker rather than feedback. So
      aria-busy goes on immediately — assistive tech should know at once — while
      the visible loader waits 150ms and never appears at all when the cart is
      quick. A slow one still gets an answer well inside the 1s that RAIL calls
      the limit of "the system is working".
    */
    startLoading() {
      this.submit.setAttribute('aria-busy', 'true');
      this.loadingTimer = setTimeout(() => {
        this.submit.setAttribute('data-loading', '');
        this.setSubmitLabel(this.dataset.loadingLabel);
      }, 150);
    }

    stopLoading() {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
      this.submit.removeAttribute('aria-busy');
      this.submit.removeAttribute('data-loading');
      this.setSubmitLabel(this.dataset.addLabel);
    }

    setSubmitLabel(label) {
      const text = this.submit.querySelector('[data-submit-label]');
      if (text && label) text.textContent = label;
    }

    /* ---- where it sits ----------------------------------------------------- */

    /*
      The panel belongs not to the page but to its own group of sections:
      itself plus the `span` of sections below it. Here it answers one question
      — active or not — while the entrance and the exit are drawn by a CSS
      transition.

      It comes in when **its resting place has entered the group**: the top of
      the card is past the group's first seam. It goes out one panel-height
      later than the mirror of that rule would take it — the card is allowed to
      hang past the last section of its group by its own height, and leaves only
      when the closing seam has climbed to the top of the card. Requiring the
      whole rectangle to stay inside took the card away the instant the seam
      touched its lower edge, and on a long spread that read as the card being
      snatched mid-scroll.

      The overhang costs nothing in the invariant that matters: two groups meet
      at one seam, and the same seam that keeps the upper panel alive (it is
      still below the card's top) is what the lower one needs to have passed, so
      at most one of them is active on any frame but the single one where the
      seam sits exactly on that line. Over a section between groups (Full
      Collection) none is active.

      The position is not calculated: it is static and lives in CSS. The script
      needs only two edges per frame, reading them is cheap, and it writes
      nothing but an attribute when the state changes.
    */
    update() {
      const resting = window.innerHeight - this.restingOffset;
      const top = resting - this.offsetHeight;

      /*
        The wrapper of the panel's own section has no height — the panel is out
        of flow — so its bottom edge is the seam with the next section. No
        separate marker element is needed for it.
      */
      const seamTop = this.section.getBoundingClientRect().bottom;
      const seamBottom = this.groupEnd.getBoundingClientRect().bottom;

      let active = seamTop <= top && seamBottom >= top;

      /*
        Insurance in case the group is stretched to the end of the page. This
        one keeps the full rectangle: the overhang above is over the next
        section of the page, and hanging over the footer is a different thing —
        there is nothing below it for the card to belong to.
      */
      if (active && this.footer) {
        active = this.footer.getBoundingClientRect().top >= resting;
      }

      this.setActive(active);
    }

    /*
      The one DOM write in the whole movement. `inert` takes the panel off the
      keyboard and away from the screen reader, `data-active` starts the CSS
      transition.

      Hovering also pauses things — WCAG 2.2.2 asks for that — which is why the
      switch happens on a state change rather than every frame: a per-frame call
      would reset that pause on the first pixel of scrolling.
    */
    setActive(value) {
      if (value === this.active) return;
      this.active = value;

      this.toggleAttribute('data-active', value);
      this.toggleAttribute('inert', !value);

      if (value) this.restartRotation();
      else this.stopRotation();
    }

    /*
      Only what cannot be read every frame is recalculated: the panel's own
      inset (which changes at the breakpoint) and the group's last section
      (which changes when the editor reorders sections). The edges themselves
      are read live in update(), so section heights need no watching.
    */
    measure() {
      this.restingOffset = parseFloat(getComputedStyle(this).insetBlockEnd) || 0;

      this.section = this.closest('.shopify-section') || this;

      const span = Number(this.dataset.span) || 1;
      this.groupEnd = this.section;
      for (let i = 0; i < span; i += 1) {
        const next = this.groupEnd.nextElementSibling;
        if (!next) break;
        this.groupEnd = next;
      }

      this.update();
    }

    watchScroll() {
      this.footer = document.querySelector('.shopify-section-group-footer-group');

      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };

      this.remeasure = () => this.measure();

      window.addEventListener('scroll', this.queue, { passive: true });
      window.addEventListener('resize', this.remeasure);
      // Images finish measuring after the document is parsed and move the seams.
      window.addEventListener('load', this.remeasure);

      // The editor reorders and replaces sections — the group's boundary moves.
      document.addEventListener('shopify:section:load', this.remeasure);
      document.addEventListener('shopify:section:unload', this.remeasure);
      document.addEventListener('shopify:section:reorder', this.remeasure);

      /*
        The first state is set before the frame and permission to animate after
        it. Otherwise the first group's panel would slide in from below on page
        load: it is active from the very start, and the transition would play an
        entrance nobody asked for.
      */
      this.measure();
      requestAnimationFrame(() => this.setAttribute('data-ready', ''));
    }
  }

  if (!customElements.get('buy-panel')) {
    customElements.define('buy-panel', BuyPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /*
    Behaviour is deliberately thin: opening and closing is the dialog's job, and
    the markup after a quantity change is Liquid's. What is left here is routing
    clicks, swapping in the section Shopify re-rendered, and putting the focus
    back where it was.
  */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.cart-drawer__dialog');
      this.panel = this.querySelector('.cart-drawer__panel');
      this.content = this.querySelector('[data-cart-content]');
      this.status = this.querySelector('[data-cart-status]');

      this.overlay = this.querySelector('.cart-drawer__overlay');

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onPanelClick = this.onPanelClick.bind(this);
      this.onCartUpdated = this.onCartUpdated.bind(this);
      this.onCancel = this.onCancel.bind(this);

      /*
        The trigger lives in the header, which is a different section and is
        itself re-rendered on every cart write — a listener bound to the link
        would not survive that. Delegating from the document does.
      */
      this.onCartRefreshed = this.onCartRefreshed.bind(this);

      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('cart:updated', this.onCartUpdated);
      document.addEventListener('cart:refreshed', this.onCartRefreshed);
      this.addEventListener('click', this.onPanelClick);

      // Esc closes a dialog instantly; this takes it through the animation.
      this.dialog.addEventListener('cancel', this.onCancel);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('cart:updated', this.onCartUpdated);
      document.removeEventListener('cart:refreshed', this.onCartRefreshed);
    }

    onDocumentClick(event) {
      const trigger = event.target.closest('[data-cart-drawer-open]');
      if (!trigger) return;

      event.preventDefault();
      this.open();
    }

    onPanelClick(event) {
      if (event.target.closest('[data-cart-drawer-close]')) {
        this.close();
        return;
      }

      const control = event.target.closest('[data-cart-step], [data-cart-remove]');
      if (!control) return;

      event.preventDefault();

      /*
        A step that has hit the stock ceiling explains itself and leaves the
        server alone: the refusal is known in advance, and the round trip would
        only add latency to a "no".
      */
      if (control.getAttribute('aria-disabled') === 'true') {
        this.showStatus(control.dataset.maxMessage || '', true);
        return;
      }

      this.changeQuantity(control);
    }

    onCartUpdated(event) {
      this.renderFrom(event);

      // Adding from the buy panel opens the drawer; a "+" inside it does not.
      if (!this.dialog.open) this.open();
    }

    /*
      A refresh is not a cart write — it happens after a refusal, to bring the
      markup back in line with what Shopify actually stored. The panel takes the
      new markup and stays exactly as open or as closed as it was: sliding out
      over an error message is the opposite of helpful.
    */
    onCartRefreshed(event) {
      this.renderFrom(event);
    }

    renderFrom(event) {
      const sections = event.detail && event.detail.sections;
      const markup = sections && sections['cart-drawer'];
      if (typeof markup === 'string') this.render(markup);
    }

    /*
      One entry point for success and for refusal: data-error decides whether
      the text is painted on screen or left to assistive tech alone.
    */
    showStatus(message, isError) {
      this.status.textContent = message;

      if (isError && message) {
        this.status.setAttribute('data-error', '');
      } else {
        this.status.removeAttribute('data-error');
      }
    }

    onCancel(event) {
      event.preventDefault();
      this.close();
    }

    /* ---- opening and closing ------------------------------------------------ */

    /*
      Movement is played through the Web Animations API rather than described in
      CSS, and that is the third attempt at this — the two CSS versions each had
      a fault you could see:

      1. [open] + @starting-style + `transition: display allow-discrete`: the
         first open landed instantly. A dialog enters the top layer and gets its
         resting style in one paint, so there is nothing to interpolate from.
      2. A [data-open] class flipped after two animation frames: it worked, but
         only as long as the attribute and the dialog's own open state agreed.
         Any close that went around close() left the attribute behind and the
         next open started already open — the "every other time" symptom.

      An explicit animation has neither problem. Its first keyframe *is* the
      starting state, so it cannot be collapsed into the same paint, and the
      state lives in the animation object rather than in an attribute that can
      drift. Cancelling one mid-flight is a single call, which is what makes
      open-close-open behave the same every time.
    */
    open() {
      // Read before showModal(): a closed dialog has no rendered panel to read.
      const from = this.dialog.open ? this.currentOffset() : '100%';

      if (!this.dialog.open) this.dialog.showModal();

      /*
        preventScroll matters: the panel is still off-screen at this point, and
        a plain focus() makes the browser scroll it into view — which is the
        sideways lurch that used to show up in the middle of the slide.
      */
      const close = this.querySelector('.cart-drawer__close');
      if (close) close.focus({ preventScroll: true });

      this.play(
        [{ transform: `translateX(${from})` }, { transform: 'translateX(0px)' }],
        [{ opacity: this.currentOpacity() }, { opacity: 0.3 }],
        { duration: 300, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' }
      );
    }

    close() {
      if (!this.dialog.open) return;

      const finished = this.play(
        [{ transform: `translateX(${this.currentOffset()})` }, { transform: 'translateX(100%)' }],
        [{ opacity: this.currentOpacity() }, { opacity: 0 }],
        { duration: 240, easing: 'cubic-bezier(0.4, 0, 1, 1)', fill: 'forwards' }
      );

      // A cancelled animation rejects; that only happens when open() took over.
      finished.then(() => this.dialog.close()).catch(() => {});
    }

    /*
      Where the panel is right now, so a drawer closed and reopened mid-slide
      carries on from there instead of snapping back to the edge first.

      Read out of the matrix rather than out of the `translate` property:
      `transform` is what every engine has animated for a decade, while the
      independent `translate` property is recent enough that WebKit's support
      for it in the Web Animations API cannot be relied on. The matrix is also
      always resolved pixels, so there is no engine-specific guessing about how
      a percentage was serialised.
    */
    currentOffset() {
      const transform = getComputedStyle(this.panel).transform;
      if (!transform || transform === 'none') return '0px';

      try {
        return `${new DOMMatrixReadOnly(transform).m41}px`;
      } catch {
        return '0px';
      }
    }

    currentOpacity() {
      return Number(getComputedStyle(this.overlay).opacity);
    }

    /*
      One place that starts both animations and hands back the panel's promise.
      Anything already running is cancelled first, so a drawer closed halfway
      and reopened travels the whole way rather than continuing from wherever it
      had got to.
    */
    play(panelFrames, overlayFrames, options) {
      if (this.panelAnimation) this.panelAnimation.cancel();
      if (this.overlayAnimation) this.overlayAnimation.cancel();

      // Reduced motion: no travel, but the dialog still has to open and close.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return Promise.resolve();
      }

      this.panelAnimation = this.panel.animate(panelFrames, options);
      this.overlayAnimation = this.overlay.animate(overlayFrames, options);

      return this.panelAnimation.finished;
    }

    async changeQuantity(control) {
      if (this.busy) return;
      this.busy = true;

      const role = control.dataset.cartStep || 'remove';
      const row = control.closest('.cart-line');

      // Where the focus has to come back to once the markup is replaced.
      this.focusTarget = { key: control.dataset.lineKey, role };

      control.setAttribute('aria-busy', 'true');

      /*
        The same 150ms the buy panel waits. Shopify answers a cart write in
        roughly 200-400ms on a warm connection, and a spinner painted on the
        first frame is a flicker rather than feedback — but a slow write still
        gets an answer well inside the second that RAIL calls the limit of
        "the system is working".
      */
      const showLoading = setTimeout(() => {
        if (row) row.setAttribute('data-loading', role === 'remove' ? 'remove' : 'quantity');
        this.content.setAttribute('data-busy', '');
      }, 150);

      try {
        await window.Theme.changeCartLine(control.dataset.lineKey, Number(control.dataset.quantity));
        this.showStatus(control.dataset.announce || '', false);
      } catch (error) {
        this.showStatus(error.message, true);
        control.removeAttribute('aria-busy');

        /*
          Shopify answers a stock overrun with 422 but still clamps the line to
          what it could give. Without this the panel would keep showing the
          number that was asked for while the cart holds another one.
        */
        await window.Theme.refreshCartSections();
      } finally {
        clearTimeout(showLoading);
        /*
          On success these nodes have already been replaced and this is a no-op
          on orphans; on failure it is what puts the row back in working order.
        */
        if (row) row.removeAttribute('data-loading');
        this.content.removeAttribute('data-busy');
        this.busy = false;
      }
    }

    render(markup) {
      const fresh = new DOMParser()
        .parseFromString(markup, 'text/html')
        .querySelector('[data-cart-content]');
      if (!fresh) return;

      /*
        Only the contents are replaced. Swapping the whole section — which is
        what the response holds — would put a fresh, closed <dialog> in place of
        the open one.
      */
      this.content.replaceChildren(...fresh.childNodes);
      this.restoreFocus();
    }

    /*
      Without this every press of "+" drops the focus to the top of the
      document, because the button that was focused no longer exists. The line
      key and the role identify its replacement; when the line itself is gone —
      the last one removed — the close button is the nearest sensible place.
    */
    restoreFocus() {
      if (!this.focusTarget) return;

      const { key, role } = this.focusTarget;
      this.focusTarget = null;

      const attribute = role === 'remove' ? 'data-cart-remove' : `data-cart-step="${role}"`;
      const next = this.querySelector(`[data-line-key="${CSS.escape(key)}"][${attribute}]`);

      if (next) {
        next.focus({ preventScroll: true });
        return;
      }

      const close = this.querySelector('.cart-drawer__close');
      if (close) close.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /*
    The reveal of the crown and of the rules, and nothing else: what to show is
    in the stylesheet above, when to show it is Theme.revealOnScroll's business
    (assets/theme.js) — it arms the element on connect and sets data-revealed
    the first time the footer is properly on screen, then stops watching.

    A footer is the last thing on the page and is very often already in view
    when the element connects — a short page, a page landed on at an anchor.
    That is the observer's own case: it fires on the first intersection whether
    or not a scroll ever happened, so the footer animates on arrival instead of
    waiting for a scroll that will not come.
  */
  class FooterReveal extends HTMLElement {
    connectedCallback() {
      Theme.revealOnScroll(this);
    }
  }

  if (!customElements.get('footer-reveal')) {
    customElements.define('footer-reveal', FooterReveal);
  }

  /*
    The footer newsletter signup.

    A custom element rather than a listener on document: the theme editor tears
    the section's DOM down and rebuilds it on every settings change, and
    connectedCallback brings the behaviour back by itself — nothing has to
    attach and detach listeners on shopify:section:load.

    The transport lives in Theme.klaviyo (assets/theme.js) — what is left here
    is only what is on screen: the spinner, the message, the accessibility.
  */
  class NewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button[type="submit"]');
      this.message = this.querySelector('[role="status"]');

      this.form.addEventListener('submit', (event) => this.onSubmit(event));
    }

    async onSubmit(event) {
      event.preventDefault();

      // The browser has already checked type="email" and required before
      // submit, so only a non-empty, syntactically valid address gets here.
      // Whether the mailbox exists nobody knows — Klaviyo answers 202 to a
      // made-up one too.
      if (this.busy) return;

      this.startLoading();

      try {
        await Theme.klaviyo.subscribe(
          this.dataset.key,
          this.dataset.list,
          this.input.value,
          'Footer newsletter'
        );
        this.say(this.dataset.success, false);
        // The field is cleared but stays where it is: the form shares a row
        // with the address and the social links, and removing it would re-lay
        // the bottom row in front of the reader.
        this.input.value = '';
      } catch (error) {
        // The reason is already in the console, written by Theme.klaviyo.
        // What goes out is neutral: "list not found" tells the shopper nothing
        // and gives away the store's configuration.
        this.say(this.dataset.error, true);
      } finally {
        this.stopLoading();
      }
    }

    say(text, isError) {
      this.message.textContent = text;

      if (isError) {
        this.input.setAttribute('aria-invalid', 'true');
      } else {
        this.input.removeAttribute('aria-invalid');
      }
    }

    /*
      aria-busy is set immediately — assistive technology is entitled to know
      at once — while the visible spinner waits 150ms and on a fast answer never
      appears at all: drawn on the first frame it reads as a flicker rather than
      as feedback. The same pair of timings is used in buy-panel.
    */
    startLoading() {
      this.busy = true;
      this.button.setAttribute('aria-busy', 'true');
      this.loadingTimer = setTimeout(() => {
        this.button.setAttribute('data-loading', '');
      }, 150);
    }

    stopLoading() {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
      this.busy = false;
      this.button.removeAttribute('aria-busy');
      this.button.removeAttribute('data-loading');
    }
  }

  if (!customElements.get('newsletter-form')) {
    customElements.define('newsletter-form', NewsletterForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
    Repaints the logo when the strip of viewport the header occupies is filled
    by dark media. A section declares itself dark with [data-header-contrast];
    everything else leaves the header in its default black-on-light state, which
    is also what a browser without IntersectionObserver support gets.

    IntersectionObserver rather than a scroll listener: no work happens on
    frames where nothing crosses the band.
  */
  class HeaderContrast extends HTMLElement {
    connectedCallback() {
      /*
        A locked page (About) keeps one colour for the whole scroll: the class
        is already on the element from Liquid, so there is nothing to set and
        nothing to observe — no IntersectionObserver, no resize listener.
      */
      if (this.dataset.contrastLock) {
        this.classList.toggle('header-contrast--light', this.dataset.contrastLock === 'light');
        return;
      }

      this.dark = new Set();
      this.scan = this.scan.bind(this);
      this.queueScan = this.queueScan.bind(this);

      // Sections live in <main>, which is parsed after the header group.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.scan, { once: true });
      } else {
        this.scan();
      }

      window.addEventListener('resize', this.queueScan);
      document.addEventListener('shopify:section:load', this.queueScan);
      document.addEventListener('shopify:section:unload', this.queueScan);
    }

    disconnectedCallback() {
      // Nothing was ever attached on a locked page.
      if (this.dataset.contrastLock) return;

      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.queueScan);
      document.removeEventListener('shopify:section:load', this.queueScan);
      document.removeEventListener('shopify:section:unload', this.queueScan);
    }

    queueScan() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(this.scan);
    }

    scan() {
      if (this.observer) this.observer.disconnect();
      this.dark.clear();

      /*
        Shrink the observer root to just the strip the header covers: its own
        height plus its offset from the top of the window, which the
        announcement bar pushes down.

        Read from the resolved `top` rather than from the box on screen. This
        runs at load and on resize, never on scroll, and a bar that scrolls away
        translates the header up as it goes — measuring the box would freeze
        whatever offset happened to be in force on the frame it was read, and
        the light-on-dark flip would fire a bar's height early or late for the
        rest of the session.
      */
      const offset = parseFloat(getComputedStyle(this).top) || 0;
      const band = this.offsetHeight + offset;
      const rest = Math.max(window.innerHeight - band, 0);

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.dark.add(entry.target);
            } else {
              this.dark.delete(entry.target);
            }
          });
          this.sync();
        },
        { rootMargin: `0px 0px -${rest}px 0px` }
      );

      document.querySelectorAll('[data-header-contrast="light"]').forEach((zone) => {
        this.observer.observe(zone);
      });

      this.sync();
    }

    sync() {
      this.classList.toggle('header-contrast--light', this.dark.size > 0);
    }
  }

  if (!customElements.get('header-contrast')) {
    customElements.define('header-contrast', HeaderContrast);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bundle"]) return;
  try {
    
  /*
    The behaviour is deliberately thin. All of the summary's markup is already
    server-rendered and hidden by the hidden attribute, and every price is
    computed and sitting as a finished string in the JSON beside it. What is
    left here is: remember the choice, reveal the rows, fill in the size and pull
    the right record out of the map. Not one request and not one money
    calculation.
  */
  class BundlePage extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-bundle-prices]');

      try {
        this.prices = source ? JSON.parse(source.textContent) : {};
      } catch (error) {
        // A broken map must not take the page down: choosing sizes still works.
        this.prices = {};
      }

      this.lines = Array.from(this.querySelectorAll('.bundle-box__line'));
      this.chosen = new Array(this.lines.length);

      /*
        Below 990 the summary becomes a sticky bar over the page, and room has
        to be reserved for it or it covers the last block. The height floats: a
        struck-through total appears and disappears inside it. Hence the bar's
        own height rather than a constant in CSS — and a ResizeObserver watches
        it, because a change of state changes the height with no reload.
      */
      this.summary = this.querySelector('.main-bundle__summary');
      if (this.summary && 'ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => {
          this.style.setProperty('--summary-height', this.summary.offsetHeight + 'px');
        });
        this.observer.observe(this.summary);
      }

      /*
        The contents box grows with every product picked, and on the second it
        outgrows the left column: the section became taller and the totals pinned
        to the bottom travelled down with it. Room for the full box is reserved
        up front — held both by the box itself and by the empty state standing in
        for it.

        A measurement rather than a constant in CSS: the height depends on the
        number of components, the screen width and the length of the titles, and
        CSS knows none of those numbers. The same trick as --summary-height
        above.
      */
      this.box = this.querySelector('.bundle-box');
      this.reserveBox = this.reserveBox.bind(this);
      this.reserveBox();
      window.addEventListener('resize', this.reserveBox);
      // The custom face arrives after parsing and changes the line heights.
      if (document.fonts) document.fonts.ready.then(this.reserveBox);

      this.form = this.querySelector('[data-bundle-form]');
      this.submit = this.querySelector('[data-bundle-submit]');
      this.submitLabel = this.querySelector('[data-bundle-submit-label]');
      this.variantInput = this.querySelector('[data-bundle-variant]');
      this.status = this.querySelector('[data-bundle-status]');

      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));

      this.render();
    }

    disconnectedCallback() {
      // The theme editor tears the section's DOM down and rebuilds it — the observer has to go.
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.reserveBox);
    }

    /*
      The rows are revealed and collapsed inside a single call with nothing but
      a geometry read between: the browser does not repaint mid-task and never
      gets to show the expanded box.

      The reservation is set on the section itself and read by the rules below
      990 — on a phone there is no box in the summary at all, so there is
      nothing to reserve.
    */
    reserveBox() {
      if (!this.box || !this.lines.length) return;

      const hiddenBefore = this.lines.map((line) => line.hidden);
      this.lines.forEach((line) => {
        line.hidden = false;
      });

      const height = this.box.getBoundingClientRect().height;

      this.lines.forEach((line, index) => {
        line.hidden = hiddenBefore[index];
      });

      if (height) this.style.setProperty('--bundle-box-height', Math.round(height) + 'px');
    }

    onChange(event) {
      const input = event.target;
      if (input.type !== 'radio' || input.dataset.componentIndex === undefined) return;

      this.chosen[Number(input.dataset.componentIndex)] = input.value;
      this.render();
    }

    onClick(event) {
      /*
        The link to the home page stays what happens without the script and on a
        middle-button or modifier click — those are not intercepted. On an
        ordinary click we step back through history, but only when there is a
        previous entry: arriving by a direct link, history.back() would take the
        shopper off the site.

        history.length counts the current entry too, hence a threshold of 1
        rather than 0.
      */
      const backLink = event.target.closest('[data-bundle-back]');
      if (backLink) {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (window.history.length <= 1) return;

        event.preventDefault();
        window.history.back();
        return;
      }

      const remove = event.target.closest('[data-line-remove]');
      if (!remove) return;

      const index = Number(remove.dataset.lineRemove);

      /*
        A radio group can only be cleared through the inputs themselves — a
        group has no "nothing selected" property.
      */
      this.querySelectorAll('input[data-component-index="' + index + '"]').forEach((input) => {
        input.checked = false;
      });

      this.chosen[index] = undefined;
      this.render();

      /*
        Focus would fall to the top of the document: the button it was on has
        just been hidden along with its row. It goes back to the first size of
        the component that was deselected.
      */
      const back = this.querySelector('input[data-component-index="' + index + '"]');
      const label = back && this.querySelector('label[for="' + CSS.escape(back.id) + '"]');
      if (label) label.focus({ preventScroll: true });
    }

    onSubmit(event) {
      event.preventDefault();
      this.addToCart();
    }

    /*
      Shopify usually answers /cart/add in 200-400ms, and a spinner drawn on
      the very first frame only has time to blink — that is a defect rather than
      feedback. So aria-busy is set at once (assistive technology has no use for
      a delay) while the visible loader waits 150ms and on a fast answer never
      appears at all. The same 150ms as the buy panel and the cart drawer.
    */
    startLoading() {
      this.submit.setAttribute('aria-busy', 'true');
      this.loadingTimer = setTimeout(() => {
        this.submit.setAttribute('data-loading', '');
        this.submitLabel.textContent = this.submit.dataset.labelAdding;
      }, 150);
    }

    stopLoading() {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
      this.submit.removeAttribute('aria-busy');
      this.submit.removeAttribute('data-loading');
      this.submitLabel.textContent = this.submit.dataset.labelReady;
    }

    async addToCart() {
      if (this.busy || !this.variantInput.value) return;
      this.busy = true;
      this.startLoading();

      try {
        /*
          The shared layer asks Shopify to re-render the header and the cart
          drawer itself and publishes cart:updated. The drawer opens on that
          event by itself — there is no need, and no way, to open it from
          here.
        */
        await window.Theme.addToCart([{ id: Number(this.variantInput.value), quantity: 1 }]);
        this.status.textContent = this.submit.dataset.labelAdded;
        this.status.removeAttribute('data-error');
      } catch (error) {
        this.status.textContent = error.message;
        this.status.setAttribute('data-error', '');
      } finally {
        this.stopLoading();
        this.busy = false;
      }
    }

    get complete() {
      return this.chosen.filter(Boolean).length === this.lines.length;
    }

    get entry() {
      if (!this.complete) return null;
      return this.prices[this.chosen.join('|')] || null;
    }

    render() {
      const entry = this.entry;

      this.lines.forEach((line, index) => {
        const size = this.chosen[index];
        line.hidden = !size;
        if (!size) return;

        const sizeCell = line.querySelector('[data-line-size]');
        if (sizeCell) sizeCell.textContent = size;

        /*
          Prices are shown only once the whole bundle is chosen: until the
          parent's variant is settled there is nowhere to get a component's share
          from, and showing the catalogue price as the final one would be a
          lie.
        */
        const money = entry ? entry.lines[index] : null;
        const now = line.querySelector('[data-line-price]');
        const was = line.querySelector('[data-line-compare]');
        const save = line.querySelector('[data-line-save]');

        if (now) now.textContent = money ? money.price : '';
        if (was) {
          was.textContent = money ? money.compare : '';
          was.hidden = !money || !money.discounted;
        }
        if (save) {
          save.textContent = money ? money.save : '';
          save.hidden = !money || !money.discounted;
        }
      });

      const subtotal = this.querySelector('[data-bundle-subtotal]');
      if (subtotal) subtotal.textContent = entry ? entry.subtotal : '';

      const compare = this.querySelector('[data-bundle-compare]');
      const compareValue = this.querySelector('[data-bundle-compare-value]');
      if (compareValue) compareValue.textContent = entry ? entry.compare : '';
      if (compare) compare.hidden = !entry || !entry.discounted;

      const chosenCount = this.chosen.filter(Boolean).length;
      const counter = this.querySelector('[data-bundle-counter]');
      if (counter) counter.textContent = chosenCount + '/' + this.lines.length;

      const boxCounter = this.querySelector('[data-bundle-box-counter]');
      if (boxCounter) boxCounter.textContent = chosenCount + '/' + this.lines.length;

      const shipping = this.querySelector('[data-bundle-shipping]');
      if (shipping) shipping.hidden = !entry;

      if (this.submit) {
        const ready = Boolean(entry) && entry.available;
        this.variantInput.value = entry ? entry.id : '';
        this.submit.disabled = !ready;
        this.submitLabel.textContent = this.complete
          ? this.submit.dataset.labelReady
          : this.submit.dataset.labelPending;
      }

      this.dispatchEvent(
        new CustomEvent('bundle:change', { detail: { entry: entry, complete: this.complete } })
      );
    }
  }

  if (!customElements.get('bundle-page')) {
    customElements.define('bundle-page', BundlePage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  /*
    A mirror of the drawer's logic, minus opening and closing. Keeping it as a
    separate copy rather than a shared base class is a deliberate trade: the
    drawer needs a <dialog> with an animation and focus returned to its trigger,
    the page needs none of that, and a common ancestor would consist mostly of
    checks on which of the two is inheriting it.

    The markup after a quantity change is Liquid's business: the section arrives
    re-rendered in the Cart API response, and all that happens here is swapping
    the nodes and putting focus back.
  */
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-cart-content]');
      this.status = this.querySelector('[data-cart-status]');

      this.onClick = this.onClick.bind(this);
      this.onCartUpdated = this.onCartUpdated.bind(this);

      this.addEventListener('click', this.onClick);
      document.addEventListener('cart:updated', this.onCartUpdated);
      document.addEventListener('cart:refreshed', this.onCartUpdated);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
      document.removeEventListener('cart:refreshed', this.onCartUpdated);
    }

    onClick(event) {
      const control = event.target.closest('[data-cart-step], [data-cart-remove]');
      if (!control) return;

      /*
        REMOVE is a real link and still works without JavaScript. It is
        intercepted only so the change stays on the page.
      */
      event.preventDefault();

      /*
        A button that has hit the stock ceiling explains that itself and never
        touches the server: the refusal is known in advance, and an extra
        request is nothing but delay.
      */
      if (control.getAttribute('aria-disabled') === 'true') {
        this.showStatus(control.dataset.maxMessage || '', true);
        return;
      }

      this.changeQuantity(control);
    }

    onCartUpdated(event) {
      const sections = event.detail && event.detail.sections;
      const markup = sections && sections['main-cart'];
      if (typeof markup === 'string') this.render(markup);
    }

    /*
      One entry point for success and for refusal: data-error decides whether
      the text is shown on screen or left to the screen reader alone.
    */
    showStatus(message, isError) {
      this.status.textContent = message;

      if (isError && message) {
        this.status.setAttribute('data-error', '');
      } else {
        this.status.removeAttribute('data-error');
      }
    }

    async changeQuantity(control) {
      if (this.busy) return;
      this.busy = true;

      const role = control.dataset.cartStep || 'remove';
      const row = control.closest('.cart-line');

      // Where focus goes once the markup has been replaced.
      this.focusTarget = { key: control.dataset.lineKey, role };

      control.setAttribute('aria-busy', 'true');

      /*
        The same 150ms as the drawer and the buy panel: Shopify answers a cart
        write in roughly 200-400ms, and a spinner drawn on the first frame is a
        flicker rather than feedback.
      */
      const showLoading = setTimeout(() => {
        if (row) row.setAttribute('data-loading', role === 'remove' ? 'remove' : 'quantity');
        this.content.setAttribute('data-busy', '');
      }, 150);

      try {
        await window.Theme.changeCartLine(control.dataset.lineKey, Number(control.dataset.quantity));
        this.showStatus(control.dataset.announce || '', false);
      } catch (error) {
        this.showStatus(error.message, true);
        control.removeAttribute('aria-busy');

        /*
          Shopify answers 422 when a quantity exceeds stock, but it trims the
          quantity to what is available — the old number would be left on screen
          while the cart holds a different one. So the markup is re-read.
        */
        await window.Theme.refreshCartSections();
      } finally {
        clearTimeout(showLoading);
        /*
          On success these nodes have already been replaced and the call does
          nothing; on an error it puts the line back into working order.
        */
        if (row) row.removeAttribute('data-loading');
        this.content.removeAttribute('data-busy');
        this.busy = false;
      }
    }

    render(markup) {
      const fresh = new DOMParser()
        .parseFromString(markup, 'text/html')
        .querySelector('[data-cart-content]');
      if (!fresh) return;

      // Contents only: the response carries the whole section, wrapper included.
      this.content.replaceChildren(...fresh.childNodes);
      this.restoreFocus();
    }

    /*
      Without this every "+" would drop focus to the top of the document: the
      button it was on no longer exists. The line key and the role identify its
      replacement; when the line itself is gone — the last one was removed — the
      heading takes focus.
    */
    restoreFocus() {
      if (!this.focusTarget) return;

      const { key, role } = this.focusTarget;
      this.focusTarget = null;

      const attribute = role === 'remove' ? 'data-cart-remove' : `data-cart-step="${role}"`;
      const next = this.querySelector(`[data-line-key="${CSS.escape(key)}"][${attribute}]`);

      if (next) {
        next.focus({ preventScroll: true });
        return;
      }

      const heading = this.querySelector('[data-cart-heading]');
      if (heading) heading.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('cart-page')) {
    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-guide"]) return;
  try {
    
  /*
    Highlights the current chapter in the table of contents. Nothing but the
    highlight: navigation is done by links, and switching JS off does not touch
    it.
  */
  class GuideContents extends HTMLElement {
    connectedCallback() {
      this.links = new Map();

      this.querySelectorAll('.guide-contents__link').forEach((link) => {
        const id = link.getAttribute('href').slice(1);
        const section = document.getElementById(id);
        if (section) this.links.set(section, link);
      });

      if (!this.links.size) return;

      /*
        The top edge is lowered under the header and the bottom edge raised
        almost to the foot of the screen: the current chapter is the one whose
        heading crosses the top quarter of the window. Otherwise the highlight
        goes out entirely on a long chapter and skips one on a short one.
      */
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.activate(this.links.get(entry.target));
          });
        },
        { rootMargin: '-20% 0px -75% 0px', threshold: 0 }
      );

      this.links.forEach((_link, section) => this.observer.observe(section));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    activate(link) {
      if (!link || link === this.current) return;

      if (this.current) this.current.removeAttribute('aria-current');
      link.setAttribute('aria-current', 'true');
      this.current = link;
    }
  }

  if (!customElements.get('guide-contents')) {
    customElements.define('guide-contents', GuideContents);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-product-variants]').textContent);
      this.idInput = this.querySelector('[data-variant-id]');
      // Both buttons (desktop and bar) carry data-submit and are served by one
      // handler: a second submit path must not exist, and only one of them is
      // visible at any moment — CSS decides which.
      this.submitButtons = [...this.querySelectorAll('[data-submit]')];
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-status]');
      this.bar = this.querySelector('[data-buy-bar]');

      this.addEventListener('change', () => this.update());

      /*
        How many of each variant are already in the cart. The markup does not
        carry it: the section cannot be re-rendered on a cart change — the chosen
        variant would be dropped — so the count arrives by event, and on first
        load it is asked for directly. Otherwise a shopper returning to the page
        with a full cart would see a live button where there is nothing left to
        take.
      */
      this.inCart = {};
      this.onCartChanged = this.onCartChanged.bind(this);
      document.addEventListener('cart:updated', this.onCartChanged);
      document.addEventListener('cart:refreshed', this.onCartChanged);
      this.onCartChanged({});

      // AJAX instead of an ordinary submit: the page does not reload and the
      // cart drawer slides out on cart:updated from assets/theme.js — a plain
      // submit breaks both. The scheme comes from buy-panel.liquid, onSubmit.
      this.onSubmit = this.onSubmit.bind(this);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);

      /*
        The Notify me popup (Task 8): both buy buttons (desktop and bar) carry
        data-submit and in the sold-out state have already been switched to
        type="button" (Task 7) — an ordinary submit will not fire, so the popup
        is opened by that same delegated click. The listener hangs on this — when
        the theme editor rebuilds the DOM it goes with the element and needs no
        manual removal, the same as this.addEventListener('change', ...)
        above.
      */
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-submit]')) {
          if (!this.current) {
            // The combination is not in the catalogue: there is nothing to buy
            // and nothing to subscribe to — no variant exists whose restock
            // could be announced. The condition used to test
            // this.current && !available, was false on undefined,
            // preventDefault never fired, and the form carried the previous
            // variant into the cart.
            event.preventDefault();
          } else if (!this.current.available) {
            event.preventDefault();
            this.openNotify();
          }
        }
        if (event.target.closest('[data-notify-close]')) {
          this.querySelector('[data-notify-dialog]').close();
        }
      });

      this.querySelector('[data-notify-form]').addEventListener('submit', (event) => {
        this.onNotifySubmit(event);
      });

      this.update();
      this.watchBar();
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);

      if (this.queueBar) window.removeEventListener('scroll', this.queueBar);
      if (this.measureBar) {
        window.removeEventListener('resize', this.measureBar);
        window.removeEventListener('load', this.measureBar);
      }
      if (this.barFrame) cancelAnimationFrame(this.barFrame);
    }

    /*
      Opens the subscription popup for the chosen (sold-out) variant. It reads
      this.current rather than recomputing the selection — by the time of the
      click update() has already brought it up to date. showModal() rather than
      open: only that gives role="dialog" out of the box, traps focus, turns Esc
      into close() and returns focus to the trigger on closing — none of which
      has to be written by hand.
    */
    openNotify() {
      const dialog = this.querySelector('[data-notify-dialog]');
      const variant = this.current;

      dialog.querySelector('[data-notify-price]').textContent = variant.price;
      variant.options.forEach((value, index) => {
        // On a product with a single variant the popup has no option row at all
        // (in the markup it is under unless has_only_default_variant), and such
        // a product can be sold out and open this popup too — without the guard
        // the script would fall over on the first access to a node that is not
        // there.
        const option = dialog.querySelector(`[data-notify-option="${index}"]`);
        if (option) option.textContent = value;

        // Only options with swatches have a square (see the markup) — a size
        // has none in the DOM at all, and the guard passes such an option over
        // silently. The colour comes from the data-colors Liquid rendered for
        // that option rather than from the DOM of the desktop set: that is
        // hidden when the popup is opened from the bar's mobile button and would
        // be unreachable in that case.
        const swatch = dialog.querySelector(`[data-notify-swatch="${index}"]`);
        if (swatch) this.paintSwatch(swatch, value);
      });

      // Klaviyo subscribes to a specific catalogue variant rather than to the
      // product, and its numeric id is the one thing the form cannot get itself
      // (it takes the email from its own field). Set here rather than in Liquid:
      // the variant is chosen on the client and changes without a reload.
      const form = dialog.querySelector('[data-notify-form]');
      form.dataset.variantId = variant.id;

      dialog.querySelector('[data-notify-done]').hidden = true;
      dialog.querySelector('[data-notify-error]').textContent = '';
      form.hidden = false;
      dialog.showModal();
    }

    /*
      Submitting the back-in-stock subscription. The transport is Theme.klaviyo
      (assets/theme.js); what is left here is the visible part.

      Success and failure behave differently on purpose: the confirmation takes
      the form's place and its focus, because the reader is standing in a modal
      and would otherwise not know what happened, while an error leaves the form
      on screen, because the attempt has to be repeatable.
    */
    async onNotifySubmit(event) {
      event.preventDefault();
      if (this.notifyBusy) return;

      const form = event.currentTarget;
      const dialog = this.querySelector('[data-notify-dialog]');
      const error = dialog.querySelector('[data-notify-error]');
      const submit = form.querySelector('[type="submit"]');

      error.textContent = '';
      this.startNotifyLoading(submit);

      try {
        await Theme.klaviyo.backInStock(
          this.dataset.klaviyoKey,
          form.querySelector('[type="email"]').value,
          form.dataset.variantId
        );

        form.hidden = true;
        const done = dialog.querySelector('[data-notify-done]');
        done.hidden = false;
        done.focus();
      } catch (requestError) {
        // The reason is already in the console, written by Theme.klaviyo. Most
        // often it is an unsynced Klaviyo catalogue, which is none of the
        // shopper's business: what goes out is neutral.
        error.textContent = this.dataset.notifyErrorLabel;
      } finally {
        this.stopNotifyLoading(submit);
      }
    }

    // aria-busy at once, the visible spinner after 150ms — a fast answer does
    // not flicker. The same timings as the cart in buy-panel and the footer
    // signup.
    startNotifyLoading(submit) {
      this.notifyBusy = true;
      submit.setAttribute('aria-busy', 'true');
      this.notifyTimer = setTimeout(() => {
        submit.setAttribute('data-loading', '');
      }, 150);
    }

    stopNotifyLoading(submit) {
      clearTimeout(this.notifyTimer);
      this.notifyTimer = null;
      this.notifyBusy = false;
      submit.removeAttribute('aria-busy');
      submit.removeAttribute('data-loading');
    }

    // The chosen values are read by option index rather than by name: the name
    // is set by the merchant and "Colour" would break the matching. Both sets of
    // controls are mounted in the DOM at once — only a media query tells them
    // apart — so the visible one is what is read, rather than both.
    selection() {
      const barVisible = this.bar && getComputedStyle(this.bar).display !== 'none';

      /*
        There are two sets, and they have to be told apart by shape rather than
        by attribute name: the desktop groups are <fieldset data-option-index>,
        while the bar holds the shared variant-select component, which puts
        data-option-index on the radios themselves. A selector with the tag
        separates them unambiguously.
      */
      const groups = barVisible
        ? [...this.bar.querySelectorAll('variant-select')]
        : [...this.querySelectorAll('fieldset[data-option-index]')];

      return groups.map((group) => group.querySelector('input:checked')?.value);
    }

    match() {
      const picked = this.selection();
      if (!picked.length) return this.variants[0];
      return this.variants.find((variant) =>
        variant.options.every((value, index) => value === picked[index])
      );
    }

    /*
      Shopify's variant matrix may be incomplete: a Color x Size product is
      entitled to have no Black/M at all. update() used to return on the first
      line for such a combination, and the whole interface — the hidden id field,
      the price, the button type — was left over from the previous variant: the
      shopper picked Black and White went into the cart. So "no such variant" is
      a state in its own right rather than an early return.
    */
    update() {
      const variant = this.match();
      this.current = variant;

      // The hidden field has no right to point at a variant nobody chose. An
      // empty value will also get through neither onSubmit (the button is marked
      // aria-disabled) nor an ordinary form submit.
      this.idInput.value = variant ? variant.id : '';

      if (variant) this.sync(variant);
      this.applyState();
      // The neighbouring cells are marked up against the person's choice rather
      // than the variant: on a non-existent combination there is no variant, and
      // the size row still has to show what is available beside it.
      this.markAvailability(variant ? variant.options : this.selection());

      /*
        The address is rewritten only when the variant has actually changed.
        update() is called from connectedCallback too, and an unconditional write
        instantly turned a clean product link into one with ?variant= — even
        though the server had served exactly that variant and there was nothing
        to add to the address.
      */
      if (variant && this.historyVariantId && variant.id !== this.historyVariantId) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      if (variant) this.historyVariantId = variant.id;
    }

    /*
      The sold-out variant state (1248-7490/7491) and the non-existent
      combination: the chip, the dimmed fill of the chosen size and the button's
      label are gathered in one method rather than smeared across update(). The
      method reads this.current and takes no arguments — stopLoading() calls it
      too, needing to ask for the state again after an AJAX call rather than
      restoring the "add to cart" label blind.
    */
    /*
      Recount how many of each variant are already in the cart and ask for the
      buttons' state again. cart:refreshed brings section markup only, so in both
      cases the count comes from the cart: out of the event where it is there,
      otherwise by request.
    */
    onCartChanged(event) {
      const cart = event && event.detail && event.detail.cart;

      if (cart && cart.items) {
        this.countInCart(cart.items);
        return;
      }

      window.Theme.fetchCart()
        .then((fresh) => this.countInCart(fresh.items))
        .catch(() => {});
    }

    countInCart(items) {
      this.inCart = {};
      items.forEach((item) => {
        this.inCart[item.variant_id] = (this.inCart[item.variant_id] || 0) + item.quantity;
      });
      this.applyState();
    }

    /*
      The variant's entire stock is already in the cart. Kept apart from
      `available`: a sold-out variant offers a subscription, while this is an
      ordinary product the shopper has simply taken all of.
    */
    maxedOut(variant) {
      if (!variant || !variant.inventoryManaged) return false;
      if (variant.inventoryPolicy === 'continue') return false;

      return ((this.inCart && this.inCart[variant.id]) || 0) >= variant.inventoryQuantity;
    }

    applyState() {
      const variant = this.current;
      const missing = !variant;
      // Neither can be bought, but for different reasons: a sold-out variant
      // offers a subscription, a non-existent one does not exist.
      const blocked = missing || !variant.available;
      const maxed = !blocked && this.maxedOut(variant);

      this.toggleAttribute('data-sold-out', blocked);

      // The price in the heading is hidden on a non-existent combination only,
      // not on a sold-out one: a sold-out variant has a price and it is honest,
      // while a non-existent one would be left with the previous choice's price
      // — the same deception as the id in the hidden field. The bar hides its own
      // price group below.
      const headlinePrice = this.querySelector('[data-price]');
      if (headlinePrice) headlinePrice.hidden = missing;

      // A product with no options (has_only_default_variant) has no chip at all
      // — a guard rather than .hidden directly, so such a product does not take
      // the script down.
      const badge = this.querySelector('[data-sold-out-badge]');
      if (badge) {
        badge.hidden = !blocked;
        badge.textContent = missing ? this.dataset.unavailableLabel : this.dataset.soldOutLabel;
      }

      let label = this.dataset.addLabel;
      if (missing) {
        label = this.dataset.unavailableLabel;
      } else if (blocked) {
        label = this.dataset.notifyLabel;
      }

      this.submitButtons.forEach((button) => {
        // type="button" stops the form going to an ordinary submit on Enter —
        // on a sold-out variant a click opens the subscription popup, on a
        // non-existent one it does nothing.
        button.type = blocked ? 'button' : 'submit';
        // aria-disabled on a non-existent combination and on exhausted stock:
        // on a sold-out variant the button works and opens the subscription. It
        // is also the second lock on submit: onSubmit tests exactly this
        // attribute.
        button.setAttribute('aria-disabled', missing || maxed ? 'true' : 'false');
        this.setSubmitLabel(button, label);

        // The bar's button also carries the price and the separator between the
        // spinner and the label — the job is only to hide them when there is
        // nothing to buy, not to take the button apart: the spinner has to
        // survive any number of size changes rather than be rebuilt each time.
        if (button.hasAttribute('data-bar-submit')) {
          const prices = button.querySelector('[data-bar-price-group]');
          const separator = button.querySelector('[data-bar-separator]');
          if (prices) prices.hidden = blocked;
          if (separator) separator.hidden = blocked;
        }
      });

      /*
        A disabled button with no explanation is a riddle, and Shopify's review
        checklist explicitly requires a message when someone tries to take more
        than is available. The reason is shown at the moment the button goes out
        rather than on click: it can no longer be clicked.
      */
      if (this.status) {
        if (maxed) {
          this.status.textContent = this.dataset.maxLabel || '';
          this.status.setAttribute('data-error', '');
        } else if (this.status.hasAttribute('data-error')) {
          this.status.textContent = '';
          this.status.removeAttribute('data-error');
        }
      }

      this.showBarFrame(variant);
    }

    /*
      Jump the bar's cut-out to the colour that was picked, when there is one.
      Matched by id, exactly as the home page panel does it
      (sections/buy-panel.liquid, applyState): it only fires if the same file is
      both the variant's image and a bar frame, so with one cut-out per product,
      as today, nothing matches and the single frame stays where it is. That is
      the point of the guard — a colour change must not blank the photo just
      because the merchant has not shot the second cut-out yet. Per-colour
      cut-outs are a shoot away, see docs/store-content.md.
    */
    showBarFrame(variant) {
      if (!this.barFrames) this.barFrames = [...this.querySelectorAll('.main-product__bar-frame')];
      if (this.barFrames.length < 2 || !variant || !variant.imageId) return;

      const next = this.barFrames.find((frame) => frame.dataset.imageId === String(variant.imageId));
      if (!next || next.hasAttribute('data-active')) return;

      this.barFrames.forEach((frame) => frame.toggleAttribute('data-active', frame === next));
    }

    /*
      One predicate for both places where a combination's availability is worked
      out (the size row and the labels in the bar's selects). It used to be
      copied verbatim twice, and a bug found in it had to be fixed twice as well.
      EVERY axis is checked without exception: skipping the axis under test would
      answer "is this value available anywhere at all" rather than "in this
      combination".
    */
    combinationAvailable(combination) {
      return this.variants.some(
        (variant) =>
          variant.available && variant.options.every((value, index) => value === combination[index])
      );
    }

    /*
      One fallback for every path that paints the square: the bar and the popup
      take the colour from the data-colors map Liquid rendered, the desktop set
      from an inline --swatch, but the rule "no colour, no square" is shared. A
      value with no swatch.color (an image swatch or one never configured) used
      to give a transparent square indistinguishable from a white one; now the
      square is hidden and the value stays readable as text beside it.
    */
    paintSwatch(node, value) {
      const colors = JSON.parse(node.dataset.colors || '{}');
      const color = colors[value];
      node.hidden = !color;
      if (color) node.style.setProperty('--swatch', color);
    }

    // Availability is worked out per combination: white in M may be sold out
    // while blue in M is not. The candidate is the current selection with one
    // axis replaced (candidate[index] = the value of the cell under test); the
    // predicate itself lives in
    // combinationAvailable().
    markAvailability(picked) {
      this.querySelectorAll('fieldset[data-option-index]').forEach((group) => {
        const index = Number(group.dataset.optionIndex);

        group.querySelectorAll('.main-product__option-value').forEach((cell) => {
          const input = cell.querySelector('input');
          const candidate = [...picked];
          candidate[index] = input.value;

          const available = this.combinationAvailable(candidate);

          cell.classList.toggle('main-product__option-value--unavailable', !available);
          cell.querySelector('[data-unavailable-note]')?.remove();

          // Colour is not the only carrier of meaning: a screen reader has to
          // hear "M, sold out" rather than silently skip an unavailable size
          // that also stays clickable.
          if (!available) {
            const note = document.createElement('span');
            note.className = 'visually-hidden';
            note.setAttribute('data-unavailable-note', '');
            note.textContent = this.dataset.soldOutLabel;
            cell.querySelector('.main-product__option-label').appendChild(note);
          }
        });
      });
    }

    // One of the two sets is changed and both have to be updated at once: touch
    // the desktop radios when a select in the bar changed, and the other way
    // round, because which set is visible switches with the screen width without
    // a reload.
    sync(variant) {
      const barSelects = this.bar ? [...this.bar.querySelectorAll('variant-select')] : [];

      variant.options.forEach((value, index) => {
        const barSelect = barSelects[index];
        if (barSelect) {
          const barRadio = barSelect.querySelector(`input[value="${CSS.escape(value)}"]`);
          if (barRadio) barRadio.checked = true;

          /*
            The unavailable marker is appended to the row's text rather than
            applied as a class: it has to be heard by a screen reader as well as
            seen. The predicate is shared with markAvailability() — see
            combinationAvailable().
          */
          barSelect.querySelectorAll('input').forEach((input) => {
            const candidate = [...variant.options];
            candidate[index] = input.value;
            const available = this.combinationAvailable(candidate);

            const label = input.parentElement.querySelector('[data-value-label]');
            if (!label) return;
            label.textContent = available
              ? input.value
              : this.dataset.unavailableTemplate.replace('VALUE', input.value);
          });

          // The check was set without a change event, so the trigger's label
          // will not update by itself — the component is asked to repaint it.
          if (typeof barSelect.syncTrigger === 'function') barSelect.syncTrigger();
        }

        const radio = this.querySelector(
          `fieldset[data-option-index="${index}"] input[value="${CSS.escape(value)}"]`
        );
        if (radio) radio.checked = true;
      });

      this.querySelectorAll('[data-price-current], [data-bar-price]').forEach((el) => {
        el.textContent = variant.price;
      });

      /*
        The discount survives a variant change: the decision was made on the
        server (Liquid compared compare_at_price with price and put either a
        finished string or null into the JSON), and all that is left here is to
        show it. The nodes are not rebuilt — their hidden is toggled — so the
        "Regular price" label for a screen reader never goes anywhere and does
        not have to be assembled in JS.
      */
      const onSale = Boolean(variant.compareAtPrice);

      this.querySelectorAll('[data-price-compare-value], [data-bar-compare-value]').forEach((el) => {
        el.textContent = variant.compareAtPrice || '';
      });

      this.querySelectorAll('[data-price-compare], [data-bar-compare]').forEach((el) => {
        el.hidden = !onSale;
      });

      this.querySelectorAll('[data-price-note]').forEach((el) => {
        el.textContent = onSale ? this.dataset.salePriceLabel : this.dataset.regularPriceLabel;
      });
    }

    /* ---- cart --------------------------------------------------------------
       The scheme from buy-panel.liquid: intercept the submit, hand the add off
       to the shared cart layer window.Theme, and report the result into the live
       region.
    */
    async onSubmit(event) {
      event.preventDefault();

      // The button is already marked unavailable — a request may be in flight,
      // for instance. A repeat submit (Enter in the form) must not start a
      // second. Both buttons are always in the same state (see
      // startLoading/stopLoading), so checking either is enough.
      if (this.submitButtons.some((button) => button.getAttribute('aria-disabled') === 'true')) return;

      if (this.status) {
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
      }
      this.startLoading();

      try {
        await window.Theme.addToCart([{ id: Number(this.idInput.value), quantity: 1 }]);
        if (this.status) {
          this.status.textContent = this.dataset.addedLabel || '';
          this.status.removeAttribute('data-error');
        }
      } catch (error) {
        if (this.status) {
          this.status.textContent = error.message;
          this.status.setAttribute('data-error', '');
        }
      } finally {
        this.stopLoading();
      }
    }

    startLoading() {
      this.submitButtons.forEach((button) => {
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('data-loading', '');
        this.setSubmitLabel(button, this.dataset.loadingLabel);
      });
    }

    stopLoading() {
      this.submitButtons.forEach((button) => {
        button.removeAttribute('aria-busy');
        button.removeAttribute('data-loading');
      });

      /*
        The label and the availability are asked for again rather than restored
        to "add to cart": on a slow connection someone can change the size while
        the request is in flight, and the button came back reading "ADD TO CART"
        even though a click already opened the subscription popup. There is one
        calculation — applyState().
      */
      this.applyState();
    }

    setSubmitLabel(button, label) {
      const text = button.querySelector('[data-submit-label]');
      if (text && label) text.textContent = label;
    }

    /* ---- the buy bar --------------------------------------------------------
       The bar lives exactly as long as its section: it is visible while its
       place at the bottom edge of the screen lies wholly inside it, and it fades
       away downward once the section has ended. Further down the page come the
       specs, the full-bleed photo and the card rows — there an "add to cart"
       button is no longer about what is on screen.

       The treatment and the animation are the home page floating panel's
       (sections/buy-panel.liquid): the reasoning for why this is a state rather
       than a coordinate is there too — a state transition cannot be caught
       halfway, a scroll-bound position can.

       The position is static and lives in CSS. The script needs one rectangle
       per frame, and it writes only an attribute and only when the answer
       changes.
    */
    watchBar() {
      if (!this.bar) return;

      this.barSection = this.closest('.shopify-section') || this.closest('.main-product');
      if (!this.barSection) return;

      this.updateBar = () => {
        /*
          Above 990 the bar is switched off by the layout (display: none) and
          has no height. There is nothing to calculate and no reason to keep it
          active: buying there lives in the ordinary form beside the photo.
        */
        if (!this.bar.offsetHeight) {
          this.setBarActive(false);
          return;
        }

        const resting = window.innerHeight - this.barResting;
        const top = resting - this.bar.offsetHeight;
        const rect = this.barSection.getBoundingClientRect();

        this.setBarActive(rect.top <= top && rect.bottom >= resting);
      };

      /*
        The bar's own inset changes at the breakpoint, so it is re-read on
        resize. The section's edges are read live in updateBar(), so the hero's
        height (100svh, floating with the address bar) no longer needs watching —
        the ResizeObserver left here along with the old anchor.
      */
      this.measureBar = () => {
        this.barResting = parseFloat(getComputedStyle(this.bar).insetBlockEnd) || 0;
        this.updateBar();
      };

      this.queueBar = () => {
        if (this.barFrame) return;
        this.barFrame = requestAnimationFrame(() => {
          this.barFrame = null;
          this.updateBar();
        });
      };

      window.addEventListener('scroll', this.queueBar, { passive: true });
      window.addEventListener('resize', this.measureBar);
      // Images finish measuring after the document is parsed and move the section's edges.
      window.addEventListener('load', this.measureBar);

      /*
        The first state is set before the frame and permission to animate after
        it. Otherwise the bar would slide in from below on page load: on the first
        screen it is active, and the transition would play an entrance nobody
        asked for.
      */
      this.measureBar();
      requestAnimationFrame(() => this.bar.setAttribute('data-ready', ''));
    }

    /*
      The one DOM write in the whole movement. `inert` takes a departed bar off
      the keyboard and away from the screen reader, `data-active` starts the CSS
      transition.
    */
    setBarActive(value) {
      if (value === this.barActive) return;
      this.barActive = value;

      this.bar.toggleAttribute('data-active', value);
      this.bar.toggleAttribute('inert', !value);
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  class MediaSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.main-product__slides');
      this.slides = [...this.querySelectorAll('.main-product__slide')];
      this.dots = [...this.querySelectorAll('[data-slide-dot]')];

      this.setActive(0);

      this.observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.find((entry) => entry.isIntersecting);
          if (visible) this.setActive(this.slides.indexOf(visible.target));
        },
        { root: this.track, threshold: 0.6 }
      );
      this.slides.forEach((slide) => this.observer.observe(slide));

      // A reference to the handler is kept rather than an inline arrow passed:
      // without it removeEventListener in disconnectedCallback would have
      // nothing to find.
      this.prevButton = this.querySelector('[data-slider-prev]');
      this.nextButton = this.querySelector('[data-slider-next]');
      this.onPrevClick = () => this.step(-1);
      this.onNextClick = () => this.step(1);
      this.prevButton?.addEventListener('click', this.onPrevClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.prevButton?.removeEventListener('click', this.onPrevClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
    }

    setActive(index) {
      this.index = index;
      this.dots.forEach((dot) => {
        dot.toggleAttribute('data-active', Number(dot.dataset.slideDot) === index);
      });
    }

    // Both ends wrap: a dead end on a button that is visible and does nothing
    // reads as a fault. The remainder is taken after adding the length, because
    // -1 % n is -1 in JavaScript and would index nothing.
    step(delta) {
      const count = this.slides.length;
      const target = this.slides[(this.index + delta + count) % count];

      // The behavior passed to scrollTo overrides CSS scroll-behavior — the
      // media query below only covers scrolling by finger and wheel, and a
      // click-driven scroll has to be switched off explicitly here. Under reduce
      // the motion is removed rather than softened: a long animated scroll can
      // trigger an episode in people with vestibular disorders.
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({
        left: target.offsetLeft - this.track.offsetLeft,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }
  }

  if (!customElements.get('media-slider')) {
    customElements.define('media-slider', MediaSlider);
  }

  class DeferredMedia extends HTMLElement {
    connectedCallback() {
      // { once: true } removes the listener itself after the first click, so
      // the leak risk is low — but the section's shared pattern of "attach in
      // connectedCallback, detach in disconnectedCallback" is kept here as well:
      // with a reference to the handler, a theme editor rebuilding the section's
      // DOM leaves no dangling subscriptions under any scenario.
      this.trigger = this.querySelector('[data-media-trigger]');
      this.onTriggerClick = () => this.load();
      this.trigger?.addEventListener('click', this.onTriggerClick, { once: true });
    }

    disconnectedCallback() {
      this.trigger?.removeEventListener('click', this.onTriggerClick);
    }

    load() {
      const template = this.querySelector('[data-media-template]');
      const player = template.content.firstElementChild.cloneNode(true);
      this.appendChild(player);
      this.trigger?.remove();

      /*
        The trigger button is removed along with focus, which falls through to
        body: the next Tab started traversal at the top of the document, and the
        video that had just been started could not be controlled from the
        keyboard without going through the whole page again (WCAG 2.4.3).
        tabindex is set only on elements that do not take focus themselves:
        <video controls> and <iframe> have their own, and tabindex="-1" would
        throw them out of the Tab order — precisely the trouble being fixed.
        preventScroll: the element is on screen anyway, the person clicked it.
      */
      if (player.tabIndex < 0) player.setAttribute('tabindex', '-1');
      player.focus({ preventScroll: true });

      const model = this.querySelector('model-viewer');
      if (model && window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([
          { name: 'model-viewer-ui', version: '1.0' },
        ]);
      }

      this.querySelector('video')?.play();
    }
  }

  if (!customElements.get('deferred-media')) {
    customElements.define('deferred-media', DeferredMedia);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["padel-facts"] && !Shopify.designMode) return;
  try {
    
  /*
    The count of meaningful actions, and showing the facts.

    All knowledge of the feature is gathered here: the listeners are delegated,
    and neither main-product nor cart-drawer nor size-guide knows anything about
    the gamification. The coupling to their attributes does exist, gathered in
    TRIGGERS and in onChange, and that is a deliberate trade — the feature may
    well be asked for removal outright, and then two files are deleted rather
    than five edited.
  */
  class PadelFacts extends HTMLElement {
    static KEY_COUNT = 'padel-facts:count';
    static KEY_SHOWN = 'padel-facts:shown';

    /* Two lines of text read in five seconds; seven leaves room to notice it. */
    static VISIBLE_MS = 7000;

    /* Has to match the exit duration in the styles of blocks/padel-fact.liquid. */
    static LEAVE_MS = 200;

    /* A pause after a drawer closes, so the toast does not slide into its animation. */
    static AFTER_DIALOG_MS = 200;

    /* 8 — the gap between the toast and the buy bar, the same as the bar keeps from the screen edge. */
    static BAR_GAP = 8;

    static TRIGGERS = [
      '[data-size-guide-open]',
      '[data-cart-drawer-open]',
      '[data-slider-next]',
      '[data-media-trigger]',
    ].join(', ');

    connectedCallback() {
      /*
        A second copy on the page keeps quiet. The section is confined to the
        footer group and there should never be two of it, but the `presets`
        setting lets a merchant add another — and two counters on one page would
        count a single action twice and show two toasts.
      */
      if (document.querySelector('padel-facts') !== this) return;

      this.current = null;
      this.pending = null;
      this.timer = null;
      this.leaveTimer = null;
      this.remaining = 0;
      this.startedAt = 0;

      this.facts = new Map();
      this.items = Array.from(this.querySelectorAll('[data-fact]'));

      this.items.forEach((node) => {
        const threshold = Number(node.dataset.clicks);

        // An empty block prints 0; a duplicate threshold goes to whoever claimed it first.
        if (threshold > 0 && !this.facts.has(threshold)) this.facts.set(threshold, node);
      });

      this.bind();
      this.watchPointer();
      this.watchBar();

      /*
        In the editor the count is switched off entirely: the merchant's clicks
        on the canvas would throw random toasts over whatever they are editing.
        In its place there is a preview on block selection.
      */
      if (window.Shopify && window.Shopify.designMode) {
        this.watchEditor();
        return;
      }

      if (this.facts.size === 0) return;

      this.restore();
      this.watchActions();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onAction);
      document.removeEventListener('change', this.onChange);
      document.removeEventListener('cart:updated', this.onCartUpdated);
      document.removeEventListener('close', this.onDialogClose, true);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);

      if (this.barState) this.barState.disconnect();
      if (this.barSize) this.barSize.disconnect();

      window.clearTimeout(this.timer);
      window.clearTimeout(this.leaveTimer);
    }

    bind() {
      this.onAction = this.onAction.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onCartUpdated = this.onCartUpdated.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);
      this.syncOffset = this.syncOffset.bind(this);

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-fact-close]')) this.hide();
      });
    }

    /* ---- what counts as an action --------------------------------------- */

    watchActions() {
      document.addEventListener('click', this.onAction);
      document.addEventListener('change', this.onChange);
      document.addEventListener('cart:updated', this.onCartUpdated);

      /*
        Capture rather than bubble: `close` on a <dialog> does not bubble, but
        the capture phase runs from document down to the target and does reach a
        listener here.
      */
      document.addEventListener('close', this.onDialogClose, true);
    }

    onAction(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      // Presses on the toast itself — the close button included — do not count as actions.
      if (target.closest('[data-fact]')) return;

      if (target.closest(PadelFacts.TRIGGERS)) this.bump();
    }

    onChange(event) {
      const control = event.target;
      if (!(control instanceof Element)) return;
      if (!control.closest('form[action$="/cart/add"]')) return;

      /*
        change rather than click: on a radio it does not fire when an already
        selected size is pressed again, so the counter cannot be run up by
        poking one value and no debounce is needed.

        Radios only, no select: the dropdown in the mobile buy bar is not native
        — snippets/variant-select.liquid is built on <details> and the same
        radios, and that was a deliberate decision for the swatches' sake. A
        speculative selector for <select> would imply a control this theme does
        not have.
      */
      if (control.matches('input[type="radio"]')) this.bump();
    }

    /*
      Any successful cart write. The drawer opens itself on one
      (cart-drawer.liquid), and its opening only counts when it came from a
      click in the header — otherwise one Add to Cart would be worth two
      actions.
    */
    onCartUpdated() {
      this.bump();
    }

    onDialogClose(event) {
      if (!(event.target instanceof HTMLDialogElement)) return;
      if (!this.pending) return;

      window.setTimeout(() => this.release(), PadelFacts.AFTER_DIALOG_MS);
    }

    /* ---- counting ------------------------------------------------------- */

    bump() {
      this.count += 1;
      this.write(PadelFacts.KEY_COUNT, String(this.count));

      const fact = this.facts.get(this.count);
      if (!fact || this.shown.has(this.count)) return;

      /*
        Marked as shown the moment the threshold is reached rather than when
        the toast appears on screen: otherwise a shopper who closes the tab with
        a fact still queued would be given it all over again.
      */
      this.shown.add(this.count);
      this.write(PadelFacts.KEY_SHOWN, Array.from(this.shown).join(','));

      /*
        A queue of one. If the next threshold is reached while a drawer is
        open, the one in between is dropped: two toasts back to back after the
        drawer closes read as a malfunction.
      */
      this.pending = fact;

      /*
        The decision to show is deferred to the next task, and that is
        necessity rather than optimisation. The listeners here and in size-guide
        hang off the same document in the bubble phase, their order between them
        decided by whose connectedCallback happened first — and opening the size
        guide managed to reach a threshold before its <dialog> got into the top
        layer. blocked() saw a clear screen and the toast slid out under the
        scrim.

        By the next task the click has reached every listener, and a drawer
        opened by that same click is already open. The same goes for the cart:
        it opens itself on cart:updated, which we listen for ourselves.
      */
      window.setTimeout(() => this.release(), 0);
    }

    // The one way in: a queued fact slides out if the screen is clear.
    release() {
      if (!this.pending || this.blocked()) return;

      this.show(this.pending, true);
    }

    /*
      Whether the screen is busy. Via dialog[open] rather than the cart's and
      the size guide's classes: both are <dialog> elements, and the rule will
      survive a third one appearing.
    */
    blocked() {
      return Boolean(document.querySelector('dialog[open]'));
    }

    /* ---- showing -------------------------------------------------------- */

    show(fact, autoHide) {
      /*
        The pending hide is cancelled, or the previous exit's timer would put
        out a card that has only just been shown again. And since the timer is
        cancelled, this method has to finish that other exit itself — without
        that the previous fact would be left transparent but still visible to a
        screen reader.
      */
      window.clearTimeout(this.leaveTimer);
      this.leaveTimer = null;

      this.items.forEach((node) => {
        if (node !== fact) this.conceal(node);
      });

      this.pending = null;
      this.current = fact;
      fact.hidden = false;

      /*
        Two frames: the removed hidden has to make it into layout before the
        attribute starts the transition. In a single frame the browser has
        nothing to interpolate from, and the first entrance plays instantly.
      */
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (this.current === fact) fact.setAttribute('data-visible', '');
        });
      });

      if (autoHide) {
        this.remaining = PadelFacts.VISIBLE_MS;
        this.resume();
      } else {
        this.remaining = 0;
      }
    }

    hide() {
      const fact = this.current;
      if (!fact) return;

      window.clearTimeout(this.timer);
      this.timer = null;
      this.current = null;
      this.remaining = 0;

      fact.removeAttribute('data-visible');
      this.leaveTimer = window.setTimeout(() => {
        fact.hidden = true;
      }, PadelFacts.LEAVE_MS);
    }

    // Instant and unanimated: only ever applied to a card that is already off screen.
    conceal(fact) {
      fact.removeAttribute('data-visible');
      fact.hidden = true;
    }

    /*
      Hover and focus hold the toast on screen: WCAG 2.2.1 requires that
      disappearing content can be kept. The listeners go on the cards themselves
      rather than the container — the container is pointer-events: none, and the
      cursor is under no obligation to land in it.
    */
    watchPointer() {
      this.items.forEach((fact) => {
        fact.addEventListener('mouseenter', () => this.pause());
        fact.addEventListener('mouseleave', () => this.resume());
        fact.addEventListener('focusin', () => this.pause());
        fact.addEventListener('focusout', () => this.resume());
      });
    }

    pause() {
      if (!this.timer) return;

      window.clearTimeout(this.timer);
      this.timer = null;
      this.remaining -= window.performance.now() - this.startedAt;
    }

    resume() {
      if (!this.current || this.remaining <= 0) return;

      window.clearTimeout(this.timer);
      this.startedAt = window.performance.now();
      this.timer = window.setTimeout(() => this.hide(), this.remaining);
    }

    /* ---- where it stands ------------------------------------------------ */

    /*
      The toast sits above the buy bar while the bar is visible and on the
      bottom of the screen when it is not. By construction, therefore, it cannot
      cover Add to Cart.

      From 990 the bar gets display: none, its offsetHeight becomes zero and the
      offset zeroes itself — no separate desktop rule is needed.
    */
    watchBar() {
      this.bar = document.querySelector('[data-buy-bar]');
      this.syncOffset();

      if (!this.bar) return;

      this.barState = new MutationObserver(this.syncOffset);
      this.barState.observe(this.bar, { attributes: true, attributeFilter: ['data-active'] });

      // The bar's height changes at the breakpoint and on a product with no options.
      this.barSize = new ResizeObserver(this.syncOffset);
      this.barSize.observe(this.bar);
    }

    syncOffset() {
      const visible = this.bar && this.bar.hasAttribute('data-active');
      const height = visible ? this.bar.offsetHeight : 0;
      const offset = height > 0 ? height + PadelFacts.BAR_GAP : 0;

      this.style.setProperty('--padel-facts-offset', `${offset}px`);
    }

    /* ---- theme editor ---------------------------------------------------- */

    /*
      Select a block, see its toast. Without this the merchant edits the copy
      blind: on the storefront the card only appears after several clicks, and
      they said outright that they would be trying numbers out.

      There is no timer in this mode — the toast stays while the block is
      selected.
    */
    watchEditor() {
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    onBlockSelect(event) {
      const fact = this.factFrom(event);
      if (fact) this.show(fact, false);
    }

    onBlockDeselect(event) {
      if (this.factFrom(event)) this.hide();
    }

    factFrom(event) {
      const target = event.target;
      if (!(target instanceof Element)) return null;

      /*
        A Shopify theme block is rendered inside a wrapper of its own
        (<div class="shopify-block">), and the editor's event arrives on that —
        the card is below it rather than above it in the tree. Hence up first,
        then down: closest on its own finds nothing here, ever.
      */
      const fact = target.closest('[data-fact]') || target.querySelector('[data-fact]');
      return fact && this.contains(fact) ? fact : null;
    }

    /* ---- storage --------------------------------------------------------- */

    /*
      sessionStorage: the counter survives navigation and reloads but dies with
      the tab. "Once per session" comes out literally, with no expiry logic, and
      it is not a durable identifier of behaviour across visits — the reasoning
      is in the spec.
    */
    restore() {
      this.count = Number(this.read(PadelFacts.KEY_COUNT)) || 0;

      const stored = this.read(PadelFacts.KEY_SHOWN);
      const seen = stored ? stored.split(',').map(Number) : [];

      this.shown = new Set(seen.filter((value) => value > 0));
    }

    // Private mode and blocked storage throw; a fact is not worth the page.
    read(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch {
        return null;
      }
    }

    write(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch {
        /* The counter lives out the page in memory — that is enough. */
      }
    }
  }

  if (!customElements.get('padel-facts')) {
    customElements.define('padel-facts', PadelFacts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature"] && !Shopify.designMode) return;
  try {
    
  /*
    The reveal of the Tech Specs bar and of the table's rules, and nothing else:
    what to show is in the stylesheet above, when to show it is
    Theme.revealOnScroll's business, and the width the bar hugs in its first
    frame is Theme.measurePlate's (both in assets/theme.js). The product page's
    table does exactly the same two calls — that is why neither of them lives in
    a component.

    A custom element rather than a listener on document: the theme editor tears
    the section's DOM down and rebuilds it on every settings change, and
    connectedCallback brings the behaviour back by itself.
  */
  class ProductFeature extends HTMLElement {
    connectedCallback() {
      Theme.measurePlate(this.querySelector('.product-feature__specs-title'));
      Theme.revealOnScroll(this);
    }
  }

  if (!customElements.get('product-feature')) {
    customElements.define('product-feature', ProductFeature);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-popup"]) return;
  try {
    
  /*
    The signup popup.

    A custom element rather than listeners on document: the theme editor tears
    the section's DOM down and rebuilds it on every settings change, and
    connectedCallback brings the behaviour back by itself.

    Everything the panel needs to be a modal — role, focus trap, Esc, focus
    returned to where it was, the rest of the page inert — belongs to <dialog>.
    What is left here is only when to open it and when to keep quiet.
  */
  class SignupPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button[type="submit"]');
      this.message = this.querySelector('[role="status"]');

      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      this.querySelectorAll('[data-signup-popup-close]').forEach((element) => {
        element.addEventListener('click', () => this.dialog.close());
      });

      /*
        The overlay carries data-signup-popup-close and is handled by the loop
        above. This is the backstop for the strip of dialog the overlay does not
        cover — there is none today, but the dialog is the full screen now and a
        click that lands on it is a click outside the card either way.
      */
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      this.dialog.addEventListener('close', () => this.onClose());

      /*
        Opening at once here is what the client complained about: the popup
        reappeared on every preview load and after every navigation, so
        editing any other section meant doing it through the popup's own
        panel. watchEditor() gives this section the same treatment
        padel-facts gives its blocks — nothing shows until the merchant
        selects it in the sidebar, and it steps aside the moment they select
        something else. Still non-modal (show(), not showModal()): the rest
        of the preview has to stay clickable.
      */
      if (window.Shopify && window.Shopify.designMode) {
        this.watchEditor();
        return;
      }

      if (this.silenced()) return;

      this.arm();
    }

    disconnectedCallback() {
      this.disarm();
      this.unwatchConsent();
      clearTimeout(this.spinnerTimer);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
    }

    watchEditor() {
      this.onSectionSelect = this.onSectionSelect.bind(this);
      this.onSectionDeselect = this.onSectionDeselect.bind(this);

      document.addEventListener('shopify:section:select', this.onSectionSelect);
      document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
    }

    /*
      Both events arrive on document with the selected section's own wrapper
      (.shopify-section) as event.target — sectionFrom(event.detail.sectionId)
      would need this element's id parsed back out of "shopify-section-<id>"
      first. Containment says the same thing more directly: this element only
      sits inside the wrapper that was just selected when the two are the
      same section.
    */
    onSectionSelect(event) {
      if (event.target instanceof Element && event.target.contains(this)) this.dialog.show();
    }

    onSectionDeselect(event) {
      if (event.target instanceof Element && event.target.contains(this) && this.dialog.open) {
        this.dialog.close();
      }
    }

    /*
      Read before anything else is set up: someone who already subscribed or
      already said no should cost this page no timer and no scroll listener at
      all.

      Storage throws outright in some privacy modes rather than returning null,
      so every access is guarded. Failing open — showing the popup once too
      often — is better than a script error that takes the form with it.
    */
    silenced() {
      try {
        if (localStorage.getItem('tiotio:popup:subscribed')) return true;

        const dismissed = Number(localStorage.getItem('tiotio:popup:dismissed'));
        if (!dismissed) return false;

        const days = Number(this.dataset.frequency);
        return Date.now() - dismissed < days * 24 * 60 * 60 * 1000;
      } catch (error) {
        return false;
      }
    }

    arm() {
      const delay = Number(this.dataset.delay);
      const scroll = Number(this.dataset.scroll);

      // Both triggers off is a deliberate setting, not a misconfiguration: it
      // is how a merchant keeps the popup editable but off the storefront.
      if (!delay && !scroll) return;

      if (delay) {
        this.timer = setTimeout(() => this.open(), delay * 1000);
      }

      if (scroll) {
        this.onScroll = () => {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          // A page shorter than the window can never reach a percentage.
          if (scrollable <= 0) return;
          if ((window.scrollY / scrollable) * 100 >= scroll) this.open();
        };

        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    disarm() {
      clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }

    /*
      Guarded so open() can call this on every re-entry while a wait is
      already in flight without stacking a second observer and a second
      event listener — see the comment in open() for why that stacking was
      the actual bug.

      The MutationObserver is scoped to the two consent elements themselves
      (attribute changes — style/class/hidden is how a banner is normally
      hidden) plus their immediate parent's child list (in case Shopify
      removes the node outright instead of hiding it), not to the whole
      document: a subtree observer on <body> would re-run this on every
      unrelated DOM change on the page for as long as the banner stays up,
      which is exactly the "something spinning in the background" a visitor
      who never answers the banner should not pay for.
    */
    watchConsent(bannerVisible) {
      if (this.consentObserver) return;

      const settle = () => {
        if (bannerVisible()) return;
        this.unwatchConsent();
        this.open();
      };

      this.consentSettle = settle;
      document.addEventListener('visitorConsentCollected', settle, { once: true });

      this.consentObserver = new MutationObserver(settle);
      document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs').forEach((element) => {
        this.consentObserver.observe(element, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden'],
        });
        if (element.parentNode) {
          this.consentObserver.observe(element.parentNode, { childList: true });
        }
      });
    }

    unwatchConsent() {
      if (this.consentObserver) {
        this.consentObserver.disconnect();
        this.consentObserver = null;
      }

      if (this.consentSettle) {
        document.removeEventListener('visitorConsentCollected', this.consentSettle);
        this.consentSettle = null;
      }
    }

    open() {
      // Whichever trigger fired first, the other one is done.
      this.disarm();

      if (this.dialog.open) return;

      /*
        Consent comes before marketing. Shopify's cookie banner is not a dialog
        — privacy-banner styles #shopify-pc__banner as a plain fixed div — so
        showModal() would put the popup in the top layer above it whatever its
        z-index, and inert the rest of the document with it: on a first visit in
        a consent region the banner ends up covered and unclickable, and below
        750 the two are both bottom-anchored and physically overlap.

        The signal is the banner's own element rather than the Customer Privacy
        API, because for most visitors — outside a consent region, or already
        answered — Shopify never injects it, and a missing element is a plain
        "no, carry on" that costs nothing and can never wait forever.
        getClientRects() rather than offsetParent: the banner is position:
        fixed, for which offsetParent is null by definition. The preferences
        dialog is checked too, since privacy-banner hides the banner while it is
        open.

        Waiting on the event alone is not safe. visitorConsentCollected is what
        Shopify dispatches the moment accept, decline or save is pressed — not
        the moment the banner has finished leaving the screen, and a CSS
        transition on the banner is enough for it to still occupy space when
        the event arrives. Re-entering open() straight from that event would
        find the banner still visible and register a second { once: true }
        listener for an event that only ever fires once per answer, so the
        popup would then wait forever. watchConsent() below keys off the
        banner's own presence instead of the event's timing: a MutationObserver
        watches for the DOM change that actually hides or removes it, whichever
        order that lands in relative to the event, and the event is kept only
        as a second path in case the hide happens through a change the
        observer's narrow filter does not catch. Both call the same idempotent
        settle(), so open() re-entering this branch while a wait is already in
        flight is a no-op rather than another stacked listener.
      */
      const bannerVisible = () =>
        Array.from(document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs')).some(
          (element) => element.getClientRects().length > 0
        );

      if (bannerVisible()) {
        this.watchConsent(bannerVisible);
        return;
      }

      /*
        Two showModal() calls stack, and the popup would land on top of the open
        cart drawer — over a panel the shopper opened on purpose, which is the
        worst possible moment to ask for an email. Wait for that one to close.
      */
      const openDialog = document.querySelector('dialog[open]');
      if (openDialog && openDialog !== this.dialog) {
        openDialog.addEventListener('close', () => this.open(), { once: true });
        return;
      }

      this.dialog.showModal();
    }

    onClose() {
      if (window.Shopify && window.Shopify.designMode) return;

      try {
        localStorage.setItem('tiotio:popup:dismissed', String(Date.now()));
      } catch (error) {
        // Nothing to do: without storage the popup comes back next visit, which
        // is annoying but not broken.
      }
    }

    async onSubmit(event) {
      event.preventDefault();

      // The browser has already checked type="email" and required before
      // submit, so only a non-empty, syntactically valid address gets here.
      // Whether the mailbox exists nobody knows — Klaviyo answers 202 to a
      // made-up one too.
      if (this.busy) return;

      this.startLoading();

      try {
        /*
          The same list as the footer form. Only the source differs: Klaviyo
          files it with the consent record and shows the merchant where the
          profile came from, so the two signup points stay distinguishable in
          the reports without a second list and a second consent.

          The 10% code is not this theme's business. Klaviyo's welcome flow
          generates a unique coupon and mails it — see docs/klaviyo.md.
        */
        await Theme.klaviyo.subscribe(
          this.dataset.key,
          this.dataset.list,
          this.input.value,
          'Signup popup'
        );

        this.say(this.dataset.success, false);
        this.input.value = '';
        this.confirm();

        /*
          Never again for this browser. Set on success rather than on close, so
          it survives someone who reads the message and then navigates away
          without closing the panel.
        */
        try {
          localStorage.setItem('tiotio:popup:subscribed', '1');
        } catch (error) {
          // See silenced(): without storage the popup returns next visit.
        }
      } catch (error) {
        // The reason is already in the console, written by Theme.klaviyo. What
        // goes out is neutral: "list not found" tells the shopper nothing and
        // gives away the store's configuration.
        this.say(this.dataset.error, true);
      } finally {
        this.stopLoading();
      }

      // Deliberately not closed on success: auto-closing is moving content
      // nobody asked for, and it takes the "check your inbox" line away before
      // it has been read.
    }

    say(text, isError) {
      this.message.textContent = text;

      if (isError) {
        this.input.setAttribute('aria-invalid', 'true');
      } else {
        this.input.removeAttribute('aria-invalid');
      }
    }

    /*
      The confirmation screen. The attribute is all the switch there is — which
      of the card's parts survive it is the stylesheet's business.

      Focus has to be moved, and not for polish: the button that was just
      pressed is about to be display: none, and focus on a removed element falls
      back to <body>, which inside a modal dialog leaves the reader with a
      trapped tab ring and nothing in it. It goes to the line itself rather than
      to the close button: focusing a heading-like node is what makes a screen
      reader read it out, and the reader has just been told to go and check
      their inbox. tabindex is set here rather than in the markup so the node is
      not a tab stop for everyone else — Tab from it reaches the close button,
      which is the only control the card has left.
    */
    confirm() {
      this.setAttribute('data-signed-up', '');
      this.message.setAttribute('tabindex', '-1');
      this.message.focus();
    }

    startLoading() {
      this.busy = true;
      this.button.setAttribute('aria-busy', 'true');
      this.message.textContent = '';

      // aria-busy goes up at once — assistive technology is entitled to know
      // immediately — while the visible spinner waits 150ms and on a fast
      // answer never appears at all. Same as the footer.
      this.spinnerTimer = setTimeout(() => {
        this.button.classList.add('is-loading');
      }, 150);
    }

    stopLoading() {
      this.busy = false;
      clearTimeout(this.spinnerTimer);
      this.button.removeAttribute('aria-busy');
      this.button.classList.remove('is-loading');
    }
  }

  if (!customElements.get('signup-popup')) {
    customElements.define('signup-popup', SignupPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist"]) return;
  try {
    
  /*
    The countdown.

    A custom element for the reason every other one in this theme is: the theme
    editor rebuilds the section's DOM on each settings change, and
    connectedCallback brings the clock back with it. disconnectedCallback stops
    the interval — without it every edit in the editor leaves another timer
    running against a detached node.

    The target is an ISO string with an explicit offset (2026-09-04T16:00:00+02:00),
    so the moment is the same for a visitor in Berlin and one in Sydney. A bare
    "2026-09-04T16:00" would be parsed in the reader's own timezone and the drop
    would open at a different instant for each of them.
  */
  class WaitlistCountdown extends HTMLElement {
    connectedCallback() {
      this.target = Date.parse(this.dataset.target);
      this.clock = this.querySelector('[data-clock]');
      this.spoken = this.querySelector('[data-spoken]');
      this.expired = this.querySelector('[data-expired-message]');

      this.cells = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };

      // An unparseable date is a merchant typo, not a visitor's problem: the
      // block removes itself rather than showing NaN across four boxes.
      if (Number.isNaN(this.target)) {
        this.hidden = true;
        return;
      }

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const remaining = this.target - Date.now();

      if (remaining <= 0) {
        this.finish();
        return;
      }

      const seconds = Math.floor(remaining / 1000);
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);

      this.cells.days.textContent = days;
      this.cells.hours.textContent = String(hours).padStart(2, '0');
      this.cells.minutes.textContent = String(minutes).padStart(2, '0');
      this.cells.seconds.textContent = String(seconds % 60).padStart(2, '0');

      // Written once per day rather than once per second: it is read on demand
      // by a screen reader, and rewriting it every tick is work nobody hears.
      if (this.spokenDays !== days) {
        this.spokenDays = days;
        this.spoken.textContent = `${days} ${this.dataset.unitDays}, ${hours} ${this.dataset.unitHours}`;
      }
    }

    finish() {
      clearInterval(this.timer);
      this.clock.hidden = true;
      this.spoken.textContent = '';

      if (this.dataset.expired) {
        this.expired.hidden = false;
      } else {
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('waitlist-countdown')) {
    customElements.define('waitlist-countdown', WaitlistCountdown);
  }

  /*
    The signup.

    Same shape as the footer's newsletter form and for the same reasons — the
    transport is Theme.klaviyo (assets/theme.js) and what lives here is only
    what is on screen. Two things differ: the confirmation replaces the form
    instead of appearing beside it, and validation is done in script because the
    <form> carries `novalidate` — the browser's own bubble is a white tooltip in
    the system font, and on a page this deliberately typeset it reads as a bug.
  */
  class WaitlistForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.field = this.querySelector('.waitlist__field');
      this.input = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button[type="submit"]');
      this.message = this.querySelector('[role="status"]');
      this.success = this.querySelector('.waitlist__success');

      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.input.addEventListener('input', () => this.clearError());
    }

    async onSubmit(event) {
      event.preventDefault();

      if (this.busy) return;

      // checkValidity covers both the empty field and a malformed address, and
      // it is the same test the browser would have run — only the reporting is
      // ours.
      if (!this.input.checkValidity()) {
        this.showError(this.input.value.trim() ? this.dataset.messageInvalid : this.dataset.messageEmpty);
        this.input.focus();
        return;
      }

      this.startLoading();

      try {
        await Theme.klaviyo.subscribe(this.dataset.key, this.dataset.list, this.input.value, 'Waitlist');
        this.showSuccess();
      } catch (error) {
        // The reason is already in the console, written by Theme.klaviyo. What
        // the visitor gets is neutral: "list not found" tells them nothing and
        // gives away how the store is wired.
        this.showError(this.dataset.error);
      } finally {
        this.stopLoading();
      }
    }

    showSuccess() {
      this.form.hidden = true;
      this.success.hidden = false;
      // The button the visitor just pressed is gone; focus would otherwise fall
      // back to <body> and a keyboard visitor would lose their place entirely.
      this.success.focus();
    }

    showError(text) {
      this.message.textContent = text;
      this.field.setAttribute('data-invalid', '');
      this.input.setAttribute('aria-invalid', 'true');
    }

    clearError() {
      this.message.textContent = '';
      this.field.removeAttribute('data-invalid');
      this.input.removeAttribute('aria-invalid');
    }

    /*
      aria-busy goes on at once — assistive technology is entitled to know — and
      the visible spinner waits 150ms so that a fast answer never draws one at
      all. On a quick connection a spinner painted on the first frame reads as a
      flicker rather than as feedback. Same pair of timings as the footer.
    */
    startLoading() {
      this.busy = true;
      this.button.setAttribute('aria-busy', 'true');
      this.loadingTimer = setTimeout(() => {
        this.button.setAttribute('data-loading', '');
      }, 150);
    }

    stopLoading() {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
      this.busy = false;
      this.button.removeAttribute('aria-busy');
      this.button.removeAttribute('data-loading');
    }
  }

  if (!customElements.get('waitlist-form')) {
    customElements.define('waitlist-form', WaitlistForm);
  }

  } catch(e) { console.error(e); }
})();
})();
